// source: all.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var brank_as_gunk_common_ctypes_all_pb = require('./../common/ctypes/all_pb.js');
goog.object.extend(proto, brank_as_gunk_common_ctypes_all_pb);
var brank_as_gunk_identity_identity_all_pb = require('./../identity/identity/all_pb.js');
goog.object.extend(proto, brank_as_gunk_identity_identity_all_pb);
var brank_as_gunk_b$enterprise_v1_fastcheckout_all_pb = require('./../b-enterprise/v1/fastcheckout/all_pb.js');
goog.object.extend(proto, brank_as_gunk_b$enterprise_v1_fastcheckout_all_pb);
goog.exportSymbol('proto.openbank.v1.admin.ActivityLog', null, global);
goog.exportSymbol('proto.openbank.v1.admin.AdminLogHistory', null, global);
goog.exportSymbol('proto.openbank.v1.admin.AdminLogType', null, global);
goog.exportSymbol('proto.openbank.v1.admin.Bank', null, global);
goog.exportSymbol('proto.openbank.v1.admin.BankSecret', null, global);
goog.exportSymbol('proto.openbank.v1.admin.BankType', null, global);
goog.exportSymbol('proto.openbank.v1.admin.BusinessOwner', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ClientDetail', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ClientDocument', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ContactDetail', null, global);
goog.exportSymbol('proto.openbank.v1.admin.CreateBankSecretRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.CreateBankSecretResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.DeleteBankSecretRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.DeleteBankSecretResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.DownloadTransactionsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.DownloadTransactionsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.EmailAdvisoryTemplate', null, global);
goog.exportSymbol('proto.openbank.v1.admin.EmailOpts', null, global);
goog.exportSymbol('proto.openbank.v1.admin.EmptyResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.File', null, global);
goog.exportSymbol('proto.openbank.v1.admin.FinancePIC', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBankSecretRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBankSecretResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBankSecretsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBankSecretsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBanksRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBanksResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetBusinessOwnerInformationRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientDetailsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientDetailsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientDocumentsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientDocumentsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientInfoRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientSearch', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetClientSearchType', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetFinancePICRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetFinancePICResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetIntegrationsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetIntegrationsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetMerchantFICredentialsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetMerchantFICredentialsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPayerFICredentialsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPayerFICredentialsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPermataCompanyInfoRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPermataCompanyInfoResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPermataDocumentsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetPermataDocumentsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetSupportingDocumentsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetSupportingDocumentsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetTransactionsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetTransactionsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetUserActivityLogRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.GetUserActivityLogResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.Integration', null, global);
goog.exportSymbol('proto.openbank.v1.admin.IsUserAuthorizedRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.IsUserAuthorizedResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.KYCDocument', null, global);
goog.exportSymbol('proto.openbank.v1.admin.KYCDocumentReview', null, global);
goog.exportSymbol('proto.openbank.v1.admin.KYCDocumentReviewRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.KYCDocumentReviewResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ListBusinessRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ListBusinessResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ListUsersRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ListUsersResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.LiveAccessFilter', null, global);
goog.exportSymbol('proto.openbank.v1.admin.OrgDocument', null, global);
goog.exportSymbol('proto.openbank.v1.admin.PermataCompanyInfo', null, global);
goog.exportSymbol('proto.openbank.v1.admin.PermataCompleteInfo', null, global);
goog.exportSymbol('proto.openbank.v1.admin.Person', null, global);
goog.exportSymbol('proto.openbank.v1.admin.ProductInfo', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RejectKYCApplicationRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RejectKYCApplicationResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveClientDocumentsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveClientDocumentsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveFinancePICRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveFinancePICResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveUserRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.RemoveUserResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SetBankStatusRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SetBankStatusResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SubmitFinancePICRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SubmitFinancePICResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SubmitSupportingDocumentsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.SubmitSupportingDocumentsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.Transaction', null, global);
goog.exportSymbol('proto.openbank.v1.admin.TransactionCountDetails', null, global);
goog.exportSymbol('proto.openbank.v1.admin.TransactionFilters', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateCompanyInformationRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateCompanyInformationResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateContactDetailRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateFIServiceRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateFIServiceResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateIntegrationStatusRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateKYCStatusRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateKYCStatusResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateOrgIsLiveRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpdateOrgIsLiveResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UploadFileRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UploadFileResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpsertPayerFICredentialsRequest', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UpsertPayerFICredentialsResponse', null, global);
goog.exportSymbol('proto.openbank.v1.admin.UserDetail', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.TransactionFilters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.TransactionFilters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.TransactionFilters.displayName = 'proto.openbank.v1.admin.TransactionFilters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.Bank = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.Bank, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.Bank.displayName = 'proto.openbank.v1.admin.Bank';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBanksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetBanksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBanksRequest.displayName = 'proto.openbank.v1.admin.GetBanksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBanksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetBanksResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetBanksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBanksResponse.displayName = 'proto.openbank.v1.admin.GetBanksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.EmailOpts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.EmailOpts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.EmailOpts.displayName = 'proto.openbank.v1.admin.EmailOpts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SetBankStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.SetBankStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SetBankStatusRequest.displayName = 'proto.openbank.v1.admin.SetBankStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SetBankStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.SetBankStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SetBankStatusResponse.displayName = 'proto.openbank.v1.admin.SetBankStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ClientDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ClientDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ClientDetail.displayName = 'proto.openbank.v1.admin.ClientDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.Person = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.Person, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.Person.displayName = 'proto.openbank.v1.admin.Person';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.TransactionCountDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.TransactionCountDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.TransactionCountDetails.displayName = 'proto.openbank.v1.admin.TransactionCountDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientSearch = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientSearch, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientSearch.displayName = 'proto.openbank.v1.admin.GetClientSearch';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientDetailsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetClientDetailsRequest.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientDetailsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientDetailsRequest.displayName = 'proto.openbank.v1.admin.GetClientDetailsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetClientDetailsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientDetailsResponse.displayName = 'proto.openbank.v1.admin.GetClientDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientInfoRequest.displayName = 'proto.openbank.v1.admin.GetClientInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.BankSecret = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.BankSecret, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.BankSecret.displayName = 'proto.openbank.v1.admin.BankSecret';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBankSecretRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetBankSecretRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBankSecretRequest.displayName = 'proto.openbank.v1.admin.GetBankSecretRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBankSecretResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetBankSecretResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBankSecretResponse.displayName = 'proto.openbank.v1.admin.GetBankSecretResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientDocumentsRequest.displayName = 'proto.openbank.v1.admin.GetClientDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.IsUserAuthorizedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.IsUserAuthorizedRequest.displayName = 'proto.openbank.v1.admin.IsUserAuthorizedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.IsUserAuthorizedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.IsUserAuthorizedResponse.displayName = 'proto.openbank.v1.admin.IsUserAuthorizedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBankSecretsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetBankSecretsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBankSecretsRequest.displayName = 'proto.openbank.v1.admin.GetBankSecretsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBankSecretsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetBankSecretsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetBankSecretsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBankSecretsResponse.displayName = 'proto.openbank.v1.admin.GetBankSecretsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.DeleteBankSecretRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.DeleteBankSecretRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.DeleteBankSecretRequest.displayName = 'proto.openbank.v1.admin.DeleteBankSecretRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.DeleteBankSecretResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.DeleteBankSecretResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.DeleteBankSecretResponse.displayName = 'proto.openbank.v1.admin.DeleteBankSecretResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.CreateBankSecretRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.CreateBankSecretRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.CreateBankSecretRequest.displayName = 'proto.openbank.v1.admin.CreateBankSecretRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.CreateBankSecretResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.CreateBankSecretResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.CreateBankSecretResponse.displayName = 'proto.openbank.v1.admin.CreateBankSecretResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateOrgIsLiveRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateOrgIsLiveRequest.displayName = 'proto.openbank.v1.admin.UpdateOrgIsLiveRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateOrgIsLiveResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateOrgIsLiveResponse.displayName = 'proto.openbank.v1.admin.UpdateOrgIsLiveResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateKYCStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateKYCStatusRequest.displayName = 'proto.openbank.v1.admin.UpdateKYCStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateKYCStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateKYCStatusResponse.displayName = 'proto.openbank.v1.admin.UpdateKYCStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetTransactionsRequest.displayName = 'proto.openbank.v1.admin.GetTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetTransactionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetTransactionsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetTransactionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetTransactionsResponse.displayName = 'proto.openbank.v1.admin.GetTransactionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.File = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.File, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.File.displayName = 'proto.openbank.v1.admin.File';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.DownloadTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.DownloadTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.DownloadTransactionsRequest.displayName = 'proto.openbank.v1.admin.DownloadTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.DownloadTransactionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.DownloadTransactionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.DownloadTransactionsResponse.displayName = 'proto.openbank.v1.admin.DownloadTransactionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.Transaction.displayName = 'proto.openbank.v1.admin.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ContactDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ContactDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ContactDetail.displayName = 'proto.openbank.v1.admin.ContactDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateCompanyInformationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateCompanyInformationRequest.displayName = 'proto.openbank.v1.admin.UpdateCompanyInformationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateContactDetailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateContactDetailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateContactDetailRequest.displayName = 'proto.openbank.v1.admin.UpdateContactDetailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateCompanyInformationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateCompanyInformationResponse.displayName = 'proto.openbank.v1.admin.UpdateCompanyInformationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ClientDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ClientDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ClientDocument.displayName = 'proto.openbank.v1.admin.ClientDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetClientDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetClientDocumentsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetClientDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetClientDocumentsResponse.displayName = 'proto.openbank.v1.admin.GetClientDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RejectKYCApplicationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RejectKYCApplicationRequest.displayName = 'proto.openbank.v1.admin.RejectKYCApplicationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RejectKYCApplicationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RejectKYCApplicationResponse.displayName = 'proto.openbank.v1.admin.RejectKYCApplicationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpsertPayerFICredentialsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.displayName = 'proto.openbank.v1.admin.UpsertPayerFICredentialsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpsertPayerFICredentialsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.displayName = 'proto.openbank.v1.admin.UpsertPayerFICredentialsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetBusinessOwnerInformationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.displayName = 'proto.openbank.v1.admin.GetBusinessOwnerInformationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.BusinessOwner = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.BusinessOwner, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.BusinessOwner.displayName = 'proto.openbank.v1.admin.BusinessOwner';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateFIServiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateFIServiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateFIServiceRequest.displayName = 'proto.openbank.v1.admin.UpdateFIServiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateFIServiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateFIServiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateFIServiceResponse.displayName = 'proto.openbank.v1.admin.UpdateFIServiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.KYCDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.KYCDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.KYCDocument.displayName = 'proto.openbank.v1.admin.KYCDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.KYCDocumentReview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.KYCDocumentReview.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.KYCDocumentReview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.KYCDocumentReview.displayName = 'proto.openbank.v1.admin.KYCDocumentReview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.KYCDocumentReviewRequest.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.KYCDocumentReviewRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.KYCDocumentReviewRequest.displayName = 'proto.openbank.v1.admin.KYCDocumentReviewRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.KYCDocumentReviewResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.KYCDocumentReviewResponse.displayName = 'proto.openbank.v1.admin.KYCDocumentReviewResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetSupportingDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetSupportingDocumentsRequest.displayName = 'proto.openbank.v1.admin.GetSupportingDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetSupportingDocumentsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetSupportingDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetSupportingDocumentsResponse.displayName = 'proto.openbank.v1.admin.GetSupportingDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetFinancePICRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetFinancePICRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetFinancePICRequest.displayName = 'proto.openbank.v1.admin.GetFinancePICRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.FinancePIC = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.FinancePIC, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.FinancePIC.displayName = 'proto.openbank.v1.admin.FinancePIC';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.OrgDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.OrgDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.OrgDocument.displayName = 'proto.openbank.v1.admin.OrgDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetFinancePICResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetFinancePICResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetFinancePICResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetFinancePICResponse.displayName = 'proto.openbank.v1.admin.GetFinancePICResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetPayerFICredentialsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPayerFICredentialsRequest.displayName = 'proto.openbank.v1.admin.GetPayerFICredentialsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetPayerFICredentialsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPayerFICredentialsResponse.displayName = 'proto.openbank.v1.admin.GetPayerFICredentialsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetMerchantFICredentialsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetMerchantFICredentialsRequest.displayName = 'proto.openbank.v1.admin.GetMerchantFICredentialsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetMerchantFICredentialsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetMerchantFICredentialsResponse.displayName = 'proto.openbank.v1.admin.GetMerchantFICredentialsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.displayName = 'proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.displayName = 'proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SubmitFinancePICRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.SubmitFinancePICRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SubmitFinancePICRequest.displayName = 'proto.openbank.v1.admin.SubmitFinancePICRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SubmitFinancePICResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.SubmitFinancePICResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.SubmitFinancePICResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SubmitFinancePICResponse.displayName = 'proto.openbank.v1.admin.SubmitFinancePICResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveFinancePICRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveFinancePICRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveFinancePICRequest.displayName = 'proto.openbank.v1.admin.RemoveFinancePICRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveFinancePICResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveFinancePICResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveFinancePICResponse.displayName = 'proto.openbank.v1.admin.RemoveFinancePICResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.SubmitSupportingDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.displayName = 'proto.openbank.v1.admin.SubmitSupportingDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.SubmitSupportingDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.displayName = 'proto.openbank.v1.admin.SubmitSupportingDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.RemoveClientDocumentsRequest.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveClientDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveClientDocumentsRequest.displayName = 'proto.openbank.v1.admin.RemoveClientDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveClientDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveClientDocumentsResponse.displayName = 'proto.openbank.v1.admin.RemoveClientDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.PermataCompanyInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.PermataCompanyInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.PermataCompanyInfo.displayName = 'proto.openbank.v1.admin.PermataCompanyInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetPermataCompanyInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPermataCompanyInfoRequest.displayName = 'proto.openbank.v1.admin.GetPermataCompanyInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetPermataCompanyInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetPermataCompanyInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPermataCompanyInfoResponse.displayName = 'proto.openbank.v1.admin.GetPermataCompanyInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.PermataCompleteInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.PermataCompleteInfo.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.PermataCompleteInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.PermataCompleteInfo.displayName = 'proto.openbank.v1.admin.PermataCompleteInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetPermataDocumentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPermataDocumentsRequest.displayName = 'proto.openbank.v1.admin.GetPermataDocumentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetPermataDocumentsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetPermataDocumentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetPermataDocumentsResponse.displayName = 'proto.openbank.v1.admin.GetPermataDocumentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ActivityLog = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ActivityLog, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ActivityLog.displayName = 'proto.openbank.v1.admin.ActivityLog';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetUserActivityLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetUserActivityLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetUserActivityLogRequest.displayName = 'proto.openbank.v1.admin.GetUserActivityLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetUserActivityLogResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetUserActivityLogResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetUserActivityLogResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetUserActivityLogResponse.displayName = 'proto.openbank.v1.admin.GetUserActivityLogResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ListBusinessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ListBusinessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ListBusinessRequest.displayName = 'proto.openbank.v1.admin.ListBusinessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ListBusinessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.ListBusinessResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.ListBusinessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ListBusinessResponse.displayName = 'proto.openbank.v1.admin.ListBusinessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ListUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.ListUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ListUsersRequest.displayName = 'proto.openbank.v1.admin.ListUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UserDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UserDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UserDetail.displayName = 'proto.openbank.v1.admin.UserDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ListUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.ListUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.ListUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ListUsersResponse.displayName = 'proto.openbank.v1.admin.ListUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveUserRequest.displayName = 'proto.openbank.v1.admin.RemoveUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.RemoveUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.RemoveUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.RemoveUserResponse.displayName = 'proto.openbank.v1.admin.RemoveUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.Integration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.Integration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.Integration.displayName = 'proto.openbank.v1.admin.Integration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.ProductInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.ProductInfo.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.ProductInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.ProductInfo.displayName = 'proto.openbank.v1.admin.ProductInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetIntegrationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.GetIntegrationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetIntegrationsRequest.displayName = 'proto.openbank.v1.admin.GetIntegrationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.GetIntegrationsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.openbank.v1.admin.GetIntegrationsResponse.repeatedFields_, null);
};
goog.inherits(proto.openbank.v1.admin.GetIntegrationsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.GetIntegrationsResponse.displayName = 'proto.openbank.v1.admin.GetIntegrationsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UpdateIntegrationStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UpdateIntegrationStatusRequest.displayName = 'proto.openbank.v1.admin.UpdateIntegrationStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.EmptyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.EmptyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.EmptyResponse.displayName = 'proto.openbank.v1.admin.EmptyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.AdminLogHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.AdminLogHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.AdminLogHistory.displayName = 'proto.openbank.v1.admin.AdminLogHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UploadFileRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UploadFileRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UploadFileRequest.displayName = 'proto.openbank.v1.admin.UploadFileRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.openbank.v1.admin.UploadFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.openbank.v1.admin.UploadFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.openbank.v1.admin.UploadFileResponse.displayName = 'proto.openbank.v1.admin.UploadFileResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.TransactionFilters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.TransactionFilters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.TransactionFilters.toObject = function(includeInstance, msg) {
  var f, obj = {
    destaccnumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    datefrom: (f = msg.getDatefrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateto: (f = msg.getDateto()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    minamount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maxamount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.TransactionFilters}
 */
proto.openbank.v1.admin.TransactionFilters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.TransactionFilters;
  return proto.openbank.v1.admin.TransactionFilters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.TransactionFilters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.TransactionFilters}
 */
proto.openbank.v1.admin.TransactionFilters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestaccnumber(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDatefrom(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateto(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinamount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxamount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.TransactionFilters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.TransactionFilters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.TransactionFilters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestaccnumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDatefrom();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateto();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMinamount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getMaxamount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string DestAccNumber = 1;
 * @return {string}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.getDestaccnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
 */
proto.openbank.v1.admin.TransactionFilters.prototype.setDestaccnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp DateFrom = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.getDatefrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
*/
proto.openbank.v1.admin.TransactionFilters.prototype.setDatefrom = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
 */
proto.openbank.v1.admin.TransactionFilters.prototype.clearDatefrom = function() {
  return this.setDatefrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.hasDatefrom = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp DateTo = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.getDateto = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
*/
proto.openbank.v1.admin.TransactionFilters.prototype.setDateto = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
 */
proto.openbank.v1.admin.TransactionFilters.prototype.clearDateto = function() {
  return this.setDateto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.hasDateto = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 MinAmount = 4;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.getMinamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
 */
proto.openbank.v1.admin.TransactionFilters.prototype.setMinamount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 MaxAmount = 5;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionFilters.prototype.getMaxamount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionFilters} returns this
 */
proto.openbank.v1.admin.TransactionFilters.prototype.setMaxamount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.Bank.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.Bank.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.Bank} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Bank.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    product: jspb.Message.getFieldWithDefault(msg, 2, 0),
    country: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    name: jspb.Message.getFieldWithDefault(msg, 5, ""),
    title: jspb.Message.getFieldWithDefault(msg, 6, ""),
    laststatusupdate: (f = msg.getLaststatusupdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.Bank}
 */
proto.openbank.v1.admin.Bank.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.Bank;
  return proto.openbank.v1.admin.Bank.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.Bank} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.Bank}
 */
proto.openbank.v1.admin.Bank.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 3:
      var value = /** @type {!proto.ctypes.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 4:
      var value = /** @type {!proto.ctypes.BankStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLaststatusupdate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.Bank.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.Bank.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.Bank} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Bank.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLaststatusupdate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 ID = 1;
 * @return {number}
 */
proto.openbank.v1.admin.Bank.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional identity.Product Product = 2;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.Bank.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ctypes.CountryISO3166 Country = 3;
 * @return {!proto.ctypes.CountryISO3166}
 */
proto.openbank.v1.admin.Bank.prototype.getCountry = function() {
  return /** @type {!proto.ctypes.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ctypes.CountryISO3166} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ctypes.BankStatus Status = 4;
 * @return {!proto.ctypes.BankStatus}
 */
proto.openbank.v1.admin.Bank.prototype.getStatus = function() {
  return /** @type {!proto.ctypes.BankStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.ctypes.BankStatus} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string Name = 5;
 * @return {string}
 */
proto.openbank.v1.admin.Bank.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string Title = 6;
 * @return {string}
 */
proto.openbank.v1.admin.Bank.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp LastStatusUpdate = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.Bank.prototype.getLaststatusupdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.Bank} returns this
*/
proto.openbank.v1.admin.Bank.prototype.setLaststatusupdate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.Bank} returns this
 */
proto.openbank.v1.admin.Bank.prototype.clearLaststatusupdate = function() {
  return this.setLaststatusupdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.Bank.prototype.hasLaststatusupdate = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBanksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBanksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBanksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    country: jspb.Message.getFieldWithDefault(msg, 1, 0),
    bankcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    product: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBanksRequest}
 */
proto.openbank.v1.admin.GetBanksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBanksRequest;
  return proto.openbank.v1.admin.GetBanksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBanksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBanksRequest}
 */
proto.openbank.v1.admin.GetBanksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.ctypes.CountryISO3166} */ (reader.readEnum());
      msg.setCountry(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBankcode(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBanksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBanksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBanksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional ctypes.CountryISO3166 Country = 1;
 * @return {!proto.ctypes.CountryISO3166}
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.getCountry = function() {
  return /** @type {!proto.ctypes.CountryISO3166} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.ctypes.CountryISO3166} value
 * @return {!proto.openbank.v1.admin.GetBanksRequest} returns this
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 BankCode = 2;
 * @return {number}
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.getBankcode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetBanksRequest} returns this
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional identity.Product Product = 3;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.GetBanksRequest} returns this
 */
proto.openbank.v1.admin.GetBanksRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetBanksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBanksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBanksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBanksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBanksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    banksList: jspb.Message.toObjectList(msg.getBanksList(),
    proto.openbank.v1.admin.Bank.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBanksResponse}
 */
proto.openbank.v1.admin.GetBanksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBanksResponse;
  return proto.openbank.v1.admin.GetBanksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBanksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBanksResponse}
 */
proto.openbank.v1.admin.GetBanksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.Bank;
      reader.readMessage(value,proto.openbank.v1.admin.Bank.deserializeBinaryFromReader);
      msg.addBanks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBanksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBanksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBanksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBanksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBanksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.Bank.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Bank Banks = 1;
 * @return {!Array<!proto.openbank.v1.admin.Bank>}
 */
proto.openbank.v1.admin.GetBanksResponse.prototype.getBanksList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.Bank>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.Bank, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.Bank>} value
 * @return {!proto.openbank.v1.admin.GetBanksResponse} returns this
*/
proto.openbank.v1.admin.GetBanksResponse.prototype.setBanksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.Bank=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.Bank}
 */
proto.openbank.v1.admin.GetBanksResponse.prototype.addBanks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.Bank, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetBanksResponse} returns this
 */
proto.openbank.v1.admin.GetBanksResponse.prototype.clearBanksList = function() {
  return this.setBanksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.EmailOpts.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.EmailOpts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.EmailOpts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.EmailOpts.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailtemplate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    note: jspb.Message.getFieldWithDefault(msg, 2, ""),
    emailtitle: jspb.Message.getFieldWithDefault(msg, 3, ""),
    emailbody: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.EmailOpts}
 */
proto.openbank.v1.admin.EmailOpts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.EmailOpts;
  return proto.openbank.v1.admin.EmailOpts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.EmailOpts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.EmailOpts}
 */
proto.openbank.v1.admin.EmailOpts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.openbank.v1.admin.EmailAdvisoryTemplate} */ (reader.readEnum());
      msg.setEmailtemplate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailtitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailbody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.EmailOpts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.EmailOpts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.EmailOpts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.EmailOpts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailtemplate();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmailtitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmailbody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional EmailAdvisoryTemplate EmailTemplate = 1;
 * @return {!proto.openbank.v1.admin.EmailAdvisoryTemplate}
 */
proto.openbank.v1.admin.EmailOpts.prototype.getEmailtemplate = function() {
  return /** @type {!proto.openbank.v1.admin.EmailAdvisoryTemplate} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.openbank.v1.admin.EmailAdvisoryTemplate} value
 * @return {!proto.openbank.v1.admin.EmailOpts} returns this
 */
proto.openbank.v1.admin.EmailOpts.prototype.setEmailtemplate = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Note = 2;
 * @return {string}
 */
proto.openbank.v1.admin.EmailOpts.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.EmailOpts} returns this
 */
proto.openbank.v1.admin.EmailOpts.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string EmailTitle = 3;
 * @return {string}
 */
proto.openbank.v1.admin.EmailOpts.prototype.getEmailtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.EmailOpts} returns this
 */
proto.openbank.v1.admin.EmailOpts.prototype.setEmailtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string EmailBody = 4;
 * @return {string}
 */
proto.openbank.v1.admin.EmailOpts.prototype.getEmailbody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.EmailOpts} returns this
 */
proto.openbank.v1.admin.EmailOpts.prototype.setEmailbody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SetBankStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SetBankStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SetBankStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    product: jspb.Message.getFieldWithDefault(msg, 2, 0),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0),
    emailopts: (f = msg.getEmailopts()) && proto.openbank.v1.admin.EmailOpts.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest}
 */
proto.openbank.v1.admin.SetBankStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SetBankStatusRequest;
  return proto.openbank.v1.admin.SetBankStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SetBankStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest}
 */
proto.openbank.v1.admin.SetBankStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 3:
      var value = /** @type {!proto.ctypes.BankStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.openbank.v1.admin.EmailOpts;
      reader.readMessage(value,proto.openbank.v1.admin.EmailOpts.deserializeBinaryFromReader);
      msg.setEmailopts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SetBankStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SetBankStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SetBankStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getEmailopts();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.openbank.v1.admin.EmailOpts.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 ID = 1;
 * @return {number}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest} returns this
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional identity.Product Product = 2;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest} returns this
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ctypes.BankStatus Status = 3;
 * @return {!proto.ctypes.BankStatus}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.ctypes.BankStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.ctypes.BankStatus} value
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest} returns this
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional EmailOpts EmailOpts = 4;
 * @return {?proto.openbank.v1.admin.EmailOpts}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.getEmailopts = function() {
  return /** @type{?proto.openbank.v1.admin.EmailOpts} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.EmailOpts, 4));
};


/**
 * @param {?proto.openbank.v1.admin.EmailOpts|undefined} value
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest} returns this
*/
proto.openbank.v1.admin.SetBankStatusRequest.prototype.setEmailopts = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.SetBankStatusRequest} returns this
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.clearEmailopts = function() {
  return this.setEmailopts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.SetBankStatusRequest.prototype.hasEmailopts = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SetBankStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SetBankStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SetBankStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SetBankStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SetBankStatusResponse}
 */
proto.openbank.v1.admin.SetBankStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SetBankStatusResponse;
  return proto.openbank.v1.admin.SetBankStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SetBankStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SetBankStatusResponse}
 */
proto.openbank.v1.admin.SetBankStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SetBankStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SetBankStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SetBankStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SetBankStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ClientDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ClientDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ClientDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ClientDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    country: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactioncount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transactioncountdetails: (f = msg.getTransactioncountdetails()) && proto.openbank.v1.admin.TransactionCountDetails.toObject(includeInstance, f),
    logourl: jspb.Message.getFieldWithDefault(msg, 6, ""),
    islive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 9, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 10, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 11, ""),
    city: jspb.Message.getFieldWithDefault(msg, 12, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    region: jspb.Message.getFieldWithDefault(msg, 14, ""),
    authorizedsignatory: (f = msg.getAuthorizedsignatory()) && proto.openbank.v1.admin.Person.toObject(includeInstance, f),
    financepic: (f = msg.getFinancepic()) && proto.openbank.v1.admin.Person.toObject(includeInstance, f),
    industry: jspb.Message.getFieldWithDefault(msg, 17, ""),
    businesstype: jspb.Message.getFieldWithDefault(msg, 18, ""),
    noemployees: jspb.Message.getFieldWithDefault(msg, 19, ""),
    transactionspermonth: jspb.Message.getFieldWithDefault(msg, 20, ""),
    role: jspb.Message.getFieldWithDefault(msg, 21, ""),
    orgtype: jspb.Message.getFieldWithDefault(msg, 22, 0),
    kycstatus: jspb.Message.getFieldWithDefault(msg, 23, 0),
    website: jspb.Message.getFieldWithDefault(msg, 24, ""),
    livedate: (f = msg.getLivedate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    placeofestablishment: jspb.Message.getFieldWithDefault(msg, 26, ""),
    dateofestablishment: jspb.Message.getFieldWithDefault(msg, 27, ""),
    hasphysicalstore: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
    companyprofile: jspb.Message.getFieldWithDefault(msg, 30, ""),
    subindustry: jspb.Message.getFieldWithDefault(msg, 31, ""),
    domiciletype: jspb.Message.getFieldWithDefault(msg, 32, 0),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 33, ""),
    agreement: jspb.Message.getFieldWithDefault(msg, 34, 0),
    estimatedtransactionvalue: jspb.Message.getFieldWithDefault(msg, 35, 0),
    revokereason: jspb.Message.getFieldWithDefault(msg, 36, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ClientDetail}
 */
proto.openbank.v1.admin.ClientDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ClientDetail;
  return proto.openbank.v1.admin.ClientDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ClientDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ClientDetail}
 */
proto.openbank.v1.admin.ClientDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTransactioncount(value);
      break;
    case 5:
      var value = new proto.openbank.v1.admin.TransactionCountDetails;
      reader.readMessage(value,proto.openbank.v1.admin.TransactionCountDetails.deserializeBinaryFromReader);
      msg.setTransactioncountdetails(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogourl(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslive(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 15:
      var value = new proto.openbank.v1.admin.Person;
      reader.readMessage(value,proto.openbank.v1.admin.Person.deserializeBinaryFromReader);
      msg.setAuthorizedsignatory(value);
      break;
    case 16:
      var value = new proto.openbank.v1.admin.Person;
      reader.readMessage(value,proto.openbank.v1.admin.Person.deserializeBinaryFromReader);
      msg.setFinancepic(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustry(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinesstype(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoemployees(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionspermonth(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 22:
      var value = /** @type {!proto.identity.OrgType} */ (reader.readEnum());
      msg.setOrgtype(value);
      break;
    case 23:
      var value = /** @type {!proto.identity.KYCStatus} */ (reader.readEnum());
      msg.setKycstatus(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    case 25:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLivedate(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceofestablishment(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofestablishment(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphysicalstore(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyprofile(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubindustry(value);
      break;
    case 32:
      var value = /** @type {!proto.identity.DomicileType} */ (reader.readEnum());
      msg.setDomiciletype(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    case 34:
      var value = /** @type {!proto.identity.Agreement} */ (reader.readEnum());
      msg.setAgreement(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstimatedtransactionvalue(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevokereason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ClientDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ClientDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ClientDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ClientDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactioncount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTransactioncountdetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.openbank.v1.admin.TransactionCountDetails.serializeBinaryToWriter
    );
  }
  f = message.getLogourl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIslive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getAuthorizedsignatory();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.openbank.v1.admin.Person.serializeBinaryToWriter
    );
  }
  f = message.getFinancepic();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.openbank.v1.admin.Person.serializeBinaryToWriter
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getBusinesstype();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getNoemployees();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getTransactionspermonth();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getOrgtype();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getKycstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getWebsite();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getLivedate();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlaceofestablishment();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getDateofestablishment();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getHasphysicalstore();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getCompanyprofile();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getSubindustry();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getDomiciletype();
  if (f !== 0.0) {
    writer.writeEnum(
      32,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getAgreement();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getEstimatedtransactionvalue();
  if (f !== 0) {
    writer.writeInt32(
      35,
      f
    );
  }
  f = message.getRevokereason();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Name = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Country = 3;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 TransactionCount = 4;
 * @return {number}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getTransactioncount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setTransactioncount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional TransactionCountDetails TransactionCountDetails = 5;
 * @return {?proto.openbank.v1.admin.TransactionCountDetails}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getTransactioncountdetails = function() {
  return /** @type{?proto.openbank.v1.admin.TransactionCountDetails} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.TransactionCountDetails, 5));
};


/**
 * @param {?proto.openbank.v1.admin.TransactionCountDetails|undefined} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
*/
proto.openbank.v1.admin.ClientDetail.prototype.setTransactioncountdetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.clearTransactioncountdetails = function() {
  return this.setTransactioncountdetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.hasTransactioncountdetails = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string LogoURL = 6;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getLogourl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setLogourl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool IsLive = 7;
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getIslive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setIslive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string PhoneNumber = 8;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string TaxIdentificationNumber = 9;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AddressLine1 = 10;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string AddressLine2 = 11;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string City = 12;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string PostalCode = 13;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Region = 14;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional Person AuthorizedSignatory = 15;
 * @return {?proto.openbank.v1.admin.Person}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getAuthorizedsignatory = function() {
  return /** @type{?proto.openbank.v1.admin.Person} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.Person, 15));
};


/**
 * @param {?proto.openbank.v1.admin.Person|undefined} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
*/
proto.openbank.v1.admin.ClientDetail.prototype.setAuthorizedsignatory = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.clearAuthorizedsignatory = function() {
  return this.setAuthorizedsignatory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.hasAuthorizedsignatory = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional Person FinancePIC = 16;
 * @return {?proto.openbank.v1.admin.Person}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getFinancepic = function() {
  return /** @type{?proto.openbank.v1.admin.Person} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.Person, 16));
};


/**
 * @param {?proto.openbank.v1.admin.Person|undefined} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
*/
proto.openbank.v1.admin.ClientDetail.prototype.setFinancepic = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.clearFinancepic = function() {
  return this.setFinancepic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.hasFinancepic = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string Industry = 17;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string BusinessType = 18;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getBusinesstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setBusinesstype = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string NoEmployees = 19;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getNoemployees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setNoemployees = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string TransactionsPerMonth = 20;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getTransactionspermonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setTransactionspermonth = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string Role = 21;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional identity.OrgType OrgType = 22;
 * @return {!proto.identity.OrgType}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getOrgtype = function() {
  return /** @type {!proto.identity.OrgType} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.identity.OrgType} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setOrgtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * optional identity.KYCStatus KYCStatus = 23;
 * @return {!proto.identity.KYCStatus}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getKycstatus = function() {
  return /** @type {!proto.identity.KYCStatus} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.identity.KYCStatus} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setKycstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional string Website = 24;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setWebsite = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional google.protobuf.Timestamp LiveDate = 25;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getLivedate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 25));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
*/
proto.openbank.v1.admin.ClientDetail.prototype.setLivedate = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.clearLivedate = function() {
  return this.setLivedate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.hasLivedate = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional string PlaceOfEstablishment = 26;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getPlaceofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setPlaceofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string DateOfEstablishment = 27;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getDateofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setDateofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional bool HasPhysicalStore = 28;
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getHasphysicalstore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setHasphysicalstore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional string CompanyProfile = 30;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getCompanyprofile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setCompanyprofile = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string SubIndustry = 31;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getSubindustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setSubindustry = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional identity.DomicileType DomicileType = 32;
 * @return {!proto.identity.DomicileType}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getDomiciletype = function() {
  return /** @type {!proto.identity.DomicileType} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {!proto.identity.DomicileType} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setDomiciletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 32, value);
};


/**
 * optional string PhoneNumberCountryCode = 33;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional identity.Agreement Agreement = 34;
 * @return {!proto.identity.Agreement}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getAgreement = function() {
  return /** @type {!proto.identity.Agreement} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.identity.Agreement} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setAgreement = function(value) {
  return jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional int32 EstimatedTransactionValue = 35;
 * @return {number}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getEstimatedtransactionvalue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setEstimatedtransactionvalue = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional string RevokeReason = 36;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDetail.prototype.getRevokereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDetail} returns this
 */
proto.openbank.v1.admin.ClientDetail.prototype.setRevokereason = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.Person.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.Person.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.Person} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Person.toObject = function(includeInstance, msg) {
  var f, obj = {
    fullname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    role: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.Person}
 */
proto.openbank.v1.admin.Person.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.Person;
  return proto.openbank.v1.admin.Person.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.Person} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.Person}
 */
proto.openbank.v1.admin.Person.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.Person.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.Person.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.Person} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Person.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string FullName = 1;
 * @return {string}
 */
proto.openbank.v1.admin.Person.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Person} returns this
 */
proto.openbank.v1.admin.Person.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Role = 2;
 * @return {string}
 */
proto.openbank.v1.admin.Person.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Person} returns this
 */
proto.openbank.v1.admin.Person.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string PhoneNumber = 3;
 * @return {string}
 */
proto.openbank.v1.admin.Person.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Person} returns this
 */
proto.openbank.v1.admin.Person.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.openbank.v1.admin.Person.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Person} returns this
 */
proto.openbank.v1.admin.Person.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PhoneNumberCountryCode = 5;
 * @return {string}
 */
proto.openbank.v1.admin.Person.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Person} returns this
 */
proto.openbank.v1.admin.Person.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.TransactionCountDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.TransactionCountDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.TransactionCountDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    directsandbox: jspb.Message.getFieldWithDefault(msg, 1, 0),
    direct: jspb.Message.getFieldWithDefault(msg, 2, 0),
    statementsandbox: jspb.Message.getFieldWithDefault(msg, 3, 0),
    statement: jspb.Message.getFieldWithDefault(msg, 4, 0),
    disburse: jspb.Message.getFieldWithDefault(msg, 5, 0),
    disbursesandbox: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.TransactionCountDetails}
 */
proto.openbank.v1.admin.TransactionCountDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.TransactionCountDetails;
  return proto.openbank.v1.admin.TransactionCountDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.TransactionCountDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.TransactionCountDetails}
 */
proto.openbank.v1.admin.TransactionCountDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDirectsandbox(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDirect(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatementsandbox(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatement(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisburse(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisbursesandbox(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.TransactionCountDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.TransactionCountDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.TransactionCountDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDirectsandbox();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDirect();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStatementsandbox();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatement();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDisburse();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getDisbursesandbox();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 DirectSandbox = 1;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getDirectsandbox = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setDirectsandbox = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 Direct = 2;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getDirect = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setDirect = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 StatementSandbox = 3;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getStatementsandbox = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setStatementsandbox = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 Statement = 4;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getStatement = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setStatement = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 Disburse = 5;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getDisburse = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setDisburse = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 DisburseSandbox = 6;
 * @return {number}
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.getDisbursesandbox = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.TransactionCountDetails} returns this
 */
proto.openbank.v1.admin.TransactionCountDetails.prototype.setDisbursesandbox = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientSearch.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientSearch.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientSearch} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientSearch.toObject = function(includeInstance, msg) {
  var f, obj = {
    searchtext: jspb.Message.getFieldWithDefault(msg, 1, ""),
    searchtype: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientSearch}
 */
proto.openbank.v1.admin.GetClientSearch.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientSearch;
  return proto.openbank.v1.admin.GetClientSearch.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientSearch} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientSearch}
 */
proto.openbank.v1.admin.GetClientSearch.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchtext(value);
      break;
    case 2:
      var value = /** @type {!proto.openbank.v1.admin.GetClientSearchType} */ (reader.readEnum());
      msg.setSearchtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientSearch.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientSearch.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientSearch} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientSearch.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSearchtext();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSearchtype();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string SearchText = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetClientSearch.prototype.getSearchtext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetClientSearch} returns this
 */
proto.openbank.v1.admin.GetClientSearch.prototype.setSearchtext = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GetClientSearchType SearchType = 2;
 * @return {!proto.openbank.v1.admin.GetClientSearchType}
 */
proto.openbank.v1.admin.GetClientSearch.prototype.getSearchtype = function() {
  return /** @type {!proto.openbank.v1.admin.GetClientSearchType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.openbank.v1.admin.GetClientSearchType} value
 * @return {!proto.openbank.v1.admin.GetClientSearch} returns this
 */
proto.openbank.v1.admin.GetClientSearch.prototype.setSearchtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetClientDetailsRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientDetailsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDetailsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    textsearch: (f = msg.getTextsearch()) && proto.openbank.v1.admin.GetClientSearch.toObject(includeInstance, f),
    countryfilter: jspb.Message.getFieldWithDefault(msg, 4, ""),
    hasliveaccessfilter: jspb.Message.getFieldWithDefault(msg, 5, 0),
    kycstatusfilterList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientDetailsRequest;
  return proto.openbank.v1.admin.GetClientDetailsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 3:
      var value = new proto.openbank.v1.admin.GetClientSearch;
      reader.readMessage(value,proto.openbank.v1.admin.GetClientSearch.deserializeBinaryFromReader);
      msg.setTextsearch(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryfilter(value);
      break;
    case 5:
      var value = /** @type {!proto.openbank.v1.admin.LiveAccessFilter} */ (reader.readEnum());
      msg.setHasliveaccessfilter(value);
      break;
    case 6:
      var value = /** @type {!Array<!proto.identity.KYCStatus>} */ (reader.readPackedEnum());
      msg.setKycstatusfilterList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientDetailsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDetailsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTextsearch();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.openbank.v1.admin.GetClientSearch.serializeBinaryToWriter
    );
  }
  f = message.getCountryfilter();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHasliveaccessfilter();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getKycstatusfilterList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
};


/**
 * optional int32 Page = 1;
 * @return {number}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 PageSize = 2;
 * @return {number}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional GetClientSearch TextSearch = 3;
 * @return {?proto.openbank.v1.admin.GetClientSearch}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getTextsearch = function() {
  return /** @type{?proto.openbank.v1.admin.GetClientSearch} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.GetClientSearch, 3));
};


/**
 * @param {?proto.openbank.v1.admin.GetClientSearch|undefined} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
*/
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setTextsearch = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.clearTextsearch = function() {
  return this.setTextsearch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.hasTextsearch = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string CountryFilter = 4;
 * @return {string}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getCountryfilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setCountryfilter = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LiveAccessFilter HasLiveAccessFilter = 5;
 * @return {!proto.openbank.v1.admin.LiveAccessFilter}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getHasliveaccessfilter = function() {
  return /** @type {!proto.openbank.v1.admin.LiveAccessFilter} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.openbank.v1.admin.LiveAccessFilter} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setHasliveaccessfilter = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated identity.KYCStatus KYCStatusFilter = 6;
 * @return {!Array<!proto.identity.KYCStatus>}
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.getKycstatusfilterList = function() {
  return /** @type {!Array<!proto.identity.KYCStatus>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.identity.KYCStatus>} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.setKycstatusfilterList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.identity.KYCStatus} value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.addKycstatusfilter = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetClientDetailsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDetailsRequest.prototype.clearKycstatusfilterList = function() {
  return this.setKycstatusfilterList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetClientDetailsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientDetailsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDetailsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientdetailsList: jspb.Message.toObjectList(msg.getClientdetailsList(),
    proto.openbank.v1.admin.ClientDetail.toObject, includeInstance),
    totalcount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientDetailsResponse}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientDetailsResponse;
  return proto.openbank.v1.admin.GetClientDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientDetailsResponse}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.ClientDetail;
      reader.readMessage(value,proto.openbank.v1.admin.ClientDetail.deserializeBinaryFromReader);
      msg.addClientdetails(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalcount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientdetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.ClientDetail.serializeBinaryToWriter
    );
  }
  f = message.getTotalcount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated ClientDetail ClientDetails = 1;
 * @return {!Array<!proto.openbank.v1.admin.ClientDetail>}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.getClientdetailsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ClientDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ClientDetail, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ClientDetail>} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsResponse} returns this
*/
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.setClientdetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.ClientDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ClientDetail}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.addClientdetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.ClientDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetClientDetailsResponse} returns this
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.clearClientdetailsList = function() {
  return this.setClientdetailsList([]);
};


/**
 * optional int32 TotalCount = 2;
 * @return {number}
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.getTotalcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetClientDetailsResponse} returns this
 */
proto.openbank.v1.admin.GetClientDetailsResponse.prototype.setTotalcount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientInfoRequest}
 */
proto.openbank.v1.admin.GetClientInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientInfoRequest;
  return proto.openbank.v1.admin.GetClientInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientInfoRequest}
 */
proto.openbank.v1.admin.GetClientInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetClientInfoRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetClientInfoRequest} returns this
 */
proto.openbank.v1.admin.GetClientInfoRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.BankSecret.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.BankSecret.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.BankSecret} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.BankSecret.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bank: jspb.Message.getFieldWithDefault(msg, 3, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdby: jspb.Message.getFieldWithDefault(msg, 5, ""),
    environment: jspb.Message.getFieldWithDefault(msg, 6, 0),
    secret: jspb.Message.getFieldWithDefault(msg, 7, ""),
    accesskey: jspb.Message.getFieldWithDefault(msg, 8, ""),
    signkey: jspb.Message.getFieldWithDefault(msg, 9, ""),
    notifykey: jspb.Message.getFieldWithDefault(msg, 10, ""),
    password: jspb.Message.getFieldWithDefault(msg, 11, ""),
    apikey: jspb.Message.getFieldWithDefault(msg, 12, ""),
    apisecret: jspb.Message.getFieldWithDefault(msg, 13, ""),
    clientid: jspb.Message.getFieldWithDefault(msg, 14, ""),
    clientsecret: jspb.Message.getFieldWithDefault(msg, 15, ""),
    partnerid: jspb.Message.getFieldWithDefault(msg, 16, ""),
    partnersecret: jspb.Message.getFieldWithDefault(msg, 17, ""),
    merchantid: jspb.Message.getFieldWithDefault(msg, 18, ""),
    merchantsecret: jspb.Message.getFieldWithDefault(msg, 19, ""),
    merchantcode: jspb.Message.getFieldWithDefault(msg, 20, ""),
    publickey: msg.getPublickey_asB64(),
    privatekey: msg.getPrivatekey_asB64(),
    publickeyfilename: jspb.Message.getFieldWithDefault(msg, 23, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.BankSecret}
 */
proto.openbank.v1.admin.BankSecret.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.BankSecret;
  return proto.openbank.v1.admin.BankSecret.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.BankSecret} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.BankSecret}
 */
proto.openbank.v1.admin.BankSecret.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBank(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedby(value);
      break;
    case 6:
      var value = /** @type {!proto.ctypes.Environment} */ (reader.readEnum());
      msg.setEnvironment(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecret(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesskey(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignkey(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotifykey(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPassword(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setApisecret(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientsecret(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerid(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnersecret(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantid(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantsecret(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setMerchantcode(value);
      break;
    case 21:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPublickey(value);
      break;
    case 22:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPrivatekey(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublickeyfilename(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.BankSecret.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.BankSecret.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.BankSecret} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.BankSecret.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBank();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEnvironment();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSecret();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAccesskey();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSignkey();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNotifykey();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getPassword();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getApikey();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getApisecret();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getClientid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getClientsecret();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPartnerid();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPartnersecret();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMerchantid();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getMerchantsecret();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getMerchantcode();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getPublickey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      21,
      f
    );
  }
  f = message.getPrivatekey_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      22,
      f
    );
  }
  f = message.getPublickeyfilename();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Bank = 3;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getBank = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setBank = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp Created = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.BankSecret.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
*/
proto.openbank.v1.admin.BankSecret.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.BankSecret.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string CreatedBy = 5;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getCreatedby = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setCreatedby = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ctypes.Environment Environment = 6;
 * @return {!proto.ctypes.Environment}
 */
proto.openbank.v1.admin.BankSecret.prototype.getEnvironment = function() {
  return /** @type {!proto.ctypes.Environment} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.ctypes.Environment} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Secret = 7;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string AccessKey = 8;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getAccesskey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setAccesskey = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string SignKey = 9;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getSignkey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setSignkey = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string NotifyKey = 10;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getNotifykey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setNotifykey = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Password = 11;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string APIKey = 12;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setApikey = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string APISecret = 13;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getApisecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setApisecret = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string ClientID = 14;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getClientid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setClientid = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string ClientSecret = 15;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getClientsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setClientsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string PartnerID = 16;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPartnerid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPartnerid = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string PartnerSecret = 17;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPartnersecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPartnersecret = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string MerchantID = 18;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getMerchantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setMerchantid = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string MerchantSecret = 19;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getMerchantsecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setMerchantsecret = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string MerchantCode = 20;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getMerchantcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setMerchantcode = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional bytes PublicKey = 21;
 * @return {!(string|Uint8Array)}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPublickey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * optional bytes PublicKey = 21;
 * This is a type-conversion wrapper around `getPublickey()`
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPublickey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPublickey()));
};


/**
 * optional bytes PublicKey = 21;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublickey()`
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPublickey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPublickey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPublickey = function(value) {
  return jspb.Message.setProto3BytesField(this, 21, value);
};


/**
 * optional bytes PrivateKey = 22;
 * @return {!(string|Uint8Array)}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPrivatekey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * optional bytes PrivateKey = 22;
 * This is a type-conversion wrapper around `getPrivatekey()`
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPrivatekey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPrivatekey()));
};


/**
 * optional bytes PrivateKey = 22;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPrivatekey()`
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPrivatekey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPrivatekey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPrivatekey = function(value) {
  return jspb.Message.setProto3BytesField(this, 22, value);
};


/**
 * optional string PublicKeyFilename = 23;
 * @return {string}
 */
proto.openbank.v1.admin.BankSecret.prototype.getPublickeyfilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BankSecret} returns this
 */
proto.openbank.v1.admin.BankSecret.prototype.setPublickeyfilename = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBankSecretRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBankSecretRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBankSecretRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBankSecretRequest}
 */
proto.openbank.v1.admin.GetBankSecretRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBankSecretRequest;
  return proto.openbank.v1.admin.GetBankSecretRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBankSecretRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBankSecretRequest}
 */
proto.openbank.v1.admin.GetBankSecretRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBankSecretRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBankSecretRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBankSecretRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetBankSecretRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetBankSecretRequest} returns this
 */
proto.openbank.v1.admin.GetBankSecretRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBankSecretResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBankSecretResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBankSecretResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    banksecret: (f = msg.getBanksecret()) && proto.openbank.v1.admin.BankSecret.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBankSecretResponse}
 */
proto.openbank.v1.admin.GetBankSecretResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBankSecretResponse;
  return proto.openbank.v1.admin.GetBankSecretResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBankSecretResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBankSecretResponse}
 */
proto.openbank.v1.admin.GetBankSecretResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.BankSecret;
      reader.readMessage(value,proto.openbank.v1.admin.BankSecret.deserializeBinaryFromReader);
      msg.setBanksecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBankSecretResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBankSecretResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBankSecretResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBanksecret();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.openbank.v1.admin.BankSecret.serializeBinaryToWriter
    );
  }
};


/**
 * optional BankSecret BankSecret = 1;
 * @return {?proto.openbank.v1.admin.BankSecret}
 */
proto.openbank.v1.admin.GetBankSecretResponse.prototype.getBanksecret = function() {
  return /** @type{?proto.openbank.v1.admin.BankSecret} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.BankSecret, 1));
};


/**
 * @param {?proto.openbank.v1.admin.BankSecret|undefined} value
 * @return {!proto.openbank.v1.admin.GetBankSecretResponse} returns this
*/
proto.openbank.v1.admin.GetBankSecretResponse.prototype.setBanksecret = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.GetBankSecretResponse} returns this
 */
proto.openbank.v1.admin.GetBankSecretResponse.prototype.clearBanksecret = function() {
  return this.setBanksecret(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.GetBankSecretResponse.prototype.hasBanksecret = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientDocumentsRequest}
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientDocumentsRequest;
  return proto.openbank.v1.admin.GetClientDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientDocumentsRequest}
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetClientDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetClientDocumentsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.IsUserAuthorizedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    endpoint: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.IsUserAuthorizedRequest}
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.IsUserAuthorizedRequest;
  return proto.openbank.v1.admin.IsUserAuthorizedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.IsUserAuthorizedRequest}
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.IsUserAuthorizedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndpoint();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string Endpoint = 1;
 * @return {string}
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.prototype.getEndpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.IsUserAuthorizedRequest} returns this
 */
proto.openbank.v1.admin.IsUserAuthorizedRequest.prototype.setEndpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.IsUserAuthorizedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.IsUserAuthorizedResponse}
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.IsUserAuthorizedResponse;
  return proto.openbank.v1.admin.IsUserAuthorizedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.IsUserAuthorizedResponse}
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.IsUserAuthorizedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.IsUserAuthorizedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.IsUserAuthorizedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBankSecretsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBankSecretsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBankSecretsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBankSecretsRequest}
 */
proto.openbank.v1.admin.GetBankSecretsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBankSecretsRequest;
  return proto.openbank.v1.admin.GetBankSecretsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBankSecretsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBankSecretsRequest}
 */
proto.openbank.v1.admin.GetBankSecretsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBankSecretsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBankSecretsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBankSecretsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetBankSecretsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetBankSecretsRequest} returns this
 */
proto.openbank.v1.admin.GetBankSecretsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetBankSecretsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBankSecretsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBankSecretsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    banksecretsList: jspb.Message.toObjectList(msg.getBanksecretsList(),
    proto.openbank.v1.admin.BankSecret.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBankSecretsResponse}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBankSecretsResponse;
  return proto.openbank.v1.admin.GetBankSecretsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBankSecretsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBankSecretsResponse}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.BankSecret;
      reader.readMessage(value,proto.openbank.v1.admin.BankSecret.deserializeBinaryFromReader);
      msg.addBanksecrets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBankSecretsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBankSecretsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBankSecretsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBanksecretsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.BankSecret.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BankSecret BankSecrets = 1;
 * @return {!Array<!proto.openbank.v1.admin.BankSecret>}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.getBanksecretsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.BankSecret>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.BankSecret, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.BankSecret>} value
 * @return {!proto.openbank.v1.admin.GetBankSecretsResponse} returns this
*/
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.setBanksecretsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.BankSecret=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.BankSecret}
 */
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.addBanksecrets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.BankSecret, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetBankSecretsResponse} returns this
 */
proto.openbank.v1.admin.GetBankSecretsResponse.prototype.clearBanksecretsList = function() {
  return this.setBanksecretsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.DeleteBankSecretRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.DeleteBankSecretRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.DeleteBankSecretRequest}
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.DeleteBankSecretRequest;
  return proto.openbank.v1.admin.DeleteBankSecretRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.DeleteBankSecretRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.DeleteBankSecretRequest}
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.DeleteBankSecretRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.DeleteBankSecretRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.DeleteBankSecretRequest} returns this
 */
proto.openbank.v1.admin.DeleteBankSecretRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.DeleteBankSecretResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.DeleteBankSecretResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.DeleteBankSecretResponse}
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.DeleteBankSecretResponse;
  return proto.openbank.v1.admin.DeleteBankSecretResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.DeleteBankSecretResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.DeleteBankSecretResponse}
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.DeleteBankSecretResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.DeleteBankSecretResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DeleteBankSecretResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.CreateBankSecretRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.CreateBankSecretRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.CreateBankSecretRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    banksecret: (f = msg.getBanksecret()) && proto.openbank.v1.admin.BankSecret.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.CreateBankSecretRequest}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.CreateBankSecretRequest;
  return proto.openbank.v1.admin.CreateBankSecretRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.CreateBankSecretRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.CreateBankSecretRequest}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.BankSecret;
      reader.readMessage(value,proto.openbank.v1.admin.BankSecret.deserializeBinaryFromReader);
      msg.setBanksecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.CreateBankSecretRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.CreateBankSecretRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.CreateBankSecretRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBanksecret();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.openbank.v1.admin.BankSecret.serializeBinaryToWriter
    );
  }
};


/**
 * optional BankSecret BankSecret = 1;
 * @return {?proto.openbank.v1.admin.BankSecret}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.getBanksecret = function() {
  return /** @type{?proto.openbank.v1.admin.BankSecret} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.BankSecret, 1));
};


/**
 * @param {?proto.openbank.v1.admin.BankSecret|undefined} value
 * @return {!proto.openbank.v1.admin.CreateBankSecretRequest} returns this
*/
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.setBanksecret = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.CreateBankSecretRequest} returns this
 */
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.clearBanksecret = function() {
  return this.setBanksecret(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.CreateBankSecretRequest.prototype.hasBanksecret = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.CreateBankSecretResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.CreateBankSecretResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.CreateBankSecretResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.CreateBankSecretResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.CreateBankSecretResponse}
 */
proto.openbank.v1.admin.CreateBankSecretResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.CreateBankSecretResponse;
  return proto.openbank.v1.admin.CreateBankSecretResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.CreateBankSecretResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.CreateBankSecretResponse}
 */
proto.openbank.v1.admin.CreateBankSecretResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.CreateBankSecretResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.CreateBankSecretResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.CreateBankSecretResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.CreateBankSecretResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateOrgIsLiveRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    islive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    revokereason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateOrgIsLiveRequest;
  return proto.openbank.v1.admin.UpdateOrgIsLiveRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRevokereason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateOrgIsLiveRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIslive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRevokereason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} returns this
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool IsLive = 2;
 * @return {boolean}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.getIslive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} returns this
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.setIslive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string RevokeReason = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.getRevokereason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveRequest} returns this
 */
proto.openbank.v1.admin.UpdateOrgIsLiveRequest.prototype.setRevokereason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateOrgIsLiveResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveResponse}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateOrgIsLiveResponse;
  return proto.openbank.v1.admin.UpdateOrgIsLiveResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateOrgIsLiveResponse}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateOrgIsLiveResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateOrgIsLiveResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateOrgIsLiveResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateKYCStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    kycstatus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    email: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusRequest}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateKYCStatusRequest;
  return proto.openbank.v1.admin.UpdateKYCStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusRequest}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.KYCStatus} */ (reader.readEnum());
      msg.setKycstatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateKYCStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKycstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional identity.KYCStatus KYCStatus = 2;
 * @return {!proto.identity.KYCStatus}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.getKycstatus = function() {
  return /** @type {!proto.identity.KYCStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.KYCStatus} value
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.setKycstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateKYCStatusRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateKYCStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusResponse}
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateKYCStatusResponse;
  return proto.openbank.v1.admin.UpdateKYCStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateKYCStatusResponse}
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateKYCStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateKYCStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateKYCStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    env: jspb.Message.getFieldWithDefault(msg, 2, ""),
    service: jspb.Message.getFieldWithDefault(msg, 3, ""),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 5, 0),
    transactionfilters: (f = msg.getTransactionfilters()) && proto.openbank.v1.admin.TransactionFilters.toObject(includeInstance, f),
    businessinfoid: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest}
 */
proto.openbank.v1.admin.GetTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetTransactionsRequest;
  return proto.openbank.v1.admin.GetTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest}
 */
proto.openbank.v1.admin.GetTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnv(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setService(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 6:
      var value = new proto.openbank.v1.admin.TransactionFilters;
      reader.readMessage(value,proto.openbank.v1.admin.TransactionFilters.deserializeBinaryFromReader);
      msg.setTransactionfilters(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessinfoid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnv();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getService();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTransactionfilters();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.openbank.v1.admin.TransactionFilters.serializeBinaryToWriter
    );
  }
  f = message.getBusinessinfoid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Env = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getEnv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setEnv = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Service = 3;
 * @return {string}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setService = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Page = 4;
 * @return {number}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 PageSize = 5;
 * @return {number}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TransactionFilters TransactionFilters = 6;
 * @return {?proto.openbank.v1.admin.TransactionFilters}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getTransactionfilters = function() {
  return /** @type{?proto.openbank.v1.admin.TransactionFilters} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.TransactionFilters, 6));
};


/**
 * @param {?proto.openbank.v1.admin.TransactionFilters|undefined} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
*/
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setTransactionfilters = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.clearTransactionfilters = function() {
  return this.setTransactionfilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.hasTransactionfilters = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string BusinessInfoID = 7;
 * @return {string}
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.getBusinessinfoid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetTransactionsRequest} returns this
 */
proto.openbank.v1.admin.GetTransactionsRequest.prototype.setBusinessinfoid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetTransactionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetTransactionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetTransactionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetTransactionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetTransactionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.openbank.v1.admin.Transaction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetTransactionsResponse}
 */
proto.openbank.v1.admin.GetTransactionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetTransactionsResponse;
  return proto.openbank.v1.admin.GetTransactionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetTransactionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetTransactionsResponse}
 */
proto.openbank.v1.admin.GetTransactionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.Transaction;
      reader.readMessage(value,proto.openbank.v1.admin.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetTransactionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetTransactionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetTransactionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetTransactionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.Transaction.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Transaction Transactions = 1;
 * @return {!Array<!proto.openbank.v1.admin.Transaction>}
 */
proto.openbank.v1.admin.GetTransactionsResponse.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.Transaction, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.Transaction>} value
 * @return {!proto.openbank.v1.admin.GetTransactionsResponse} returns this
*/
proto.openbank.v1.admin.GetTransactionsResponse.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.Transaction}
 */
proto.openbank.v1.admin.GetTransactionsResponse.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetTransactionsResponse} returns this
 */
proto.openbank.v1.admin.GetTransactionsResponse.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.File.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.File.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.File} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.File.toObject = function(includeInstance, msg) {
  var f, obj = {
    filename: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: msg.getData_asB64(),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.File}
 */
proto.openbank.v1.admin.File.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.File;
  return proto.openbank.v1.admin.File.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.File} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.File}
 */
proto.openbank.v1.admin.File.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.File.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.File.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.File} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.File.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string Filename = 1;
 * @return {string}
 */
proto.openbank.v1.admin.File.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.File} returns this
 */
proto.openbank.v1.admin.File.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bytes Data = 2;
 * @return {!(string|Uint8Array)}
 */
proto.openbank.v1.admin.File.prototype.getData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes Data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */
proto.openbank.v1.admin.File.prototype.getData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getData()));
};


/**
 * optional bytes Data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.File.prototype.getData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.openbank.v1.admin.File} returns this
 */
proto.openbank.v1.admin.File.prototype.setData = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional int32 Size = 3;
 * @return {number}
 */
proto.openbank.v1.admin.File.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.File} returns this
 */
proto.openbank.v1.admin.File.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.DownloadTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.DownloadTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    env: jspb.Message.getFieldWithDefault(msg, 2, ""),
    service: jspb.Message.getFieldWithDefault(msg, 3, ""),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 5, 0),
    transactionfilters: (f = msg.getTransactionfilters()) && proto.openbank.v1.admin.TransactionFilters.toObject(includeInstance, f),
    businessinfoid: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.DownloadTransactionsRequest;
  return proto.openbank.v1.admin.DownloadTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.DownloadTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnv(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setService(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    case 6:
      var value = new proto.openbank.v1.admin.TransactionFilters;
      reader.readMessage(value,proto.openbank.v1.admin.TransactionFilters.deserializeBinaryFromReader);
      msg.setTransactionfilters(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessinfoid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.DownloadTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.DownloadTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnv();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getService();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTransactionfilters();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.openbank.v1.admin.TransactionFilters.serializeBinaryToWriter
    );
  }
  f = message.getBusinessinfoid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Env = 2;
 * @return {string}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getEnv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setEnv = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Service = 3;
 * @return {string}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getService = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setService = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Page = 4;
 * @return {number}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 PageSize = 5;
 * @return {number}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TransactionFilters TransactionFilters = 6;
 * @return {?proto.openbank.v1.admin.TransactionFilters}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getTransactionfilters = function() {
  return /** @type{?proto.openbank.v1.admin.TransactionFilters} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.TransactionFilters, 6));
};


/**
 * @param {?proto.openbank.v1.admin.TransactionFilters|undefined} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
*/
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setTransactionfilters = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.clearTransactionfilters = function() {
  return this.setTransactionfilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.hasTransactionfilters = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string BusinessInfoID = 7;
 * @return {string}
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.getBusinessinfoid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsRequest} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsRequest.prototype.setBusinessinfoid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.DownloadTransactionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.DownloadTransactionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionsfile: (f = msg.getTransactionsfile()) && proto.openbank.v1.admin.File.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsResponse}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.DownloadTransactionsResponse;
  return proto.openbank.v1.admin.DownloadTransactionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.DownloadTransactionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsResponse}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.File;
      reader.readMessage(value,proto.openbank.v1.admin.File.deserializeBinaryFromReader);
      msg.setTransactionsfile(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.DownloadTransactionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.DownloadTransactionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionsfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.openbank.v1.admin.File.serializeBinaryToWriter
    );
  }
};


/**
 * optional File TransactionsFile = 1;
 * @return {?proto.openbank.v1.admin.File}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.getTransactionsfile = function() {
  return /** @type{?proto.openbank.v1.admin.File} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.File, 1));
};


/**
 * @param {?proto.openbank.v1.admin.File|undefined} value
 * @return {!proto.openbank.v1.admin.DownloadTransactionsResponse} returns this
*/
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.setTransactionsfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.DownloadTransactionsResponse} returns this
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.clearTransactionsfile = function() {
  return this.setTransactionsfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.DownloadTransactionsResponse.prototype.hasTransactionsfile = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sourcebankname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sourceaccountnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    destbankname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    destaccountnumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 7, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 8, ""),
    status: jspb.Message.getFieldWithDefault(msg, 9, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 10, 0),
    startdate: (f = msg.getStartdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    enddate: (f = msg.getEnddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.Transaction}
 */
proto.openbank.v1.admin.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.Transaction;
  return proto.openbank.v1.admin.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.Transaction}
 */
proto.openbank.v1.admin.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourcebankname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceaccountnumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestbankname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDestaccountnumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAmount(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 10:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartdate(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSourcebankname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSourceaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDestbankname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDestaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAmount();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getStartdate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnddate();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp Created = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.Transaction.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
*/
proto.openbank.v1.admin.Transaction.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.Transaction.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string SourceBankName = 3;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getSourcebankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setSourcebankname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string SourceAccountNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getSourceaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setSourceaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string DestBankName = 5;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getDestbankname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setDestbankname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string DestAccountNumber = 6;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getDestaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setDestaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Amount = 7;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getAmount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setAmount = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string Currency = 8;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Status = 9;
 * @return {string}
 */
proto.openbank.v1.admin.Transaction.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional fastcheckout.BankCode BankCode = 10;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.openbank.v1.admin.Transaction.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp StartDate = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.Transaction.prototype.getStartdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
*/
proto.openbank.v1.admin.Transaction.prototype.setStartdate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.clearStartdate = function() {
  return this.setStartdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.Transaction.prototype.hasStartdate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp EndDate = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.Transaction.prototype.getEnddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.Transaction} returns this
*/
proto.openbank.v1.admin.Transaction.prototype.setEnddate = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.Transaction} returns this
 */
proto.openbank.v1.admin.Transaction.prototype.clearEnddate = function() {
  return this.setEnddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.Transaction.prototype.hasEnddate = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ContactDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ContactDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ContactDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ContactDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ContactDetail}
 */
proto.openbank.v1.admin.ContactDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ContactDetail;
  return proto.openbank.v1.admin.ContactDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ContactDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ContactDetail}
 */
proto.openbank.v1.admin.ContactDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ContactDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ContactDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ContactDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ContactDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FullName = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Role = 3;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PhoneNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Email = 5;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string PhoneNumberCountryCode = 6;
 * @return {string}
 */
proto.openbank.v1.admin.ContactDetail.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ContactDetail} returns this
 */
proto.openbank.v1.admin.ContactDetail.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateCompanyInformationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 5, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 6, ""),
    city: jspb.Message.getFieldWithDefault(msg, 7, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    website: jspb.Message.getFieldWithDefault(msg, 9, ""),
    region: jspb.Message.getFieldWithDefault(msg, 10, ""),
    country: jspb.Message.getFieldWithDefault(msg, 11, ""),
    businesstype: jspb.Message.getFieldWithDefault(msg, 12, ""),
    role: jspb.Message.getFieldWithDefault(msg, 13, ""),
    industry: jspb.Message.getFieldWithDefault(msg, 14, ""),
    noemployees: jspb.Message.getFieldWithDefault(msg, 15, ""),
    transactionspermonth: jspb.Message.getFieldWithDefault(msg, 16, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 18, ""),
    financepic: (f = msg.getFinancepic()) && proto.openbank.v1.admin.UpdateContactDetailRequest.toObject(includeInstance, f),
    authorizedsignatory: (f = msg.getAuthorizedsignatory()) && proto.openbank.v1.admin.UpdateContactDetailRequest.toObject(includeInstance, f),
    orgtype: jspb.Message.getFieldWithDefault(msg, 21, 0),
    placeofestablishment: jspb.Message.getFieldWithDefault(msg, 22, ""),
    dateofestablishment: jspb.Message.getFieldWithDefault(msg, 23, ""),
    hasphysicalstore: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    companyprofile: jspb.Message.getFieldWithDefault(msg, 25, ""),
    subindustry: jspb.Message.getFieldWithDefault(msg, 26, ""),
    agreement: jspb.Message.getFieldWithDefault(msg, 27, 0),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 28, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateCompanyInformationRequest;
  return proto.openbank.v1.admin.UpdateCompanyInformationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsite(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinesstype(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustry(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setNoemployees(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionspermonth(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 19:
      var value = new proto.openbank.v1.admin.UpdateContactDetailRequest;
      reader.readMessage(value,proto.openbank.v1.admin.UpdateContactDetailRequest.deserializeBinaryFromReader);
      msg.setFinancepic(value);
      break;
    case 20:
      var value = new proto.openbank.v1.admin.UpdateContactDetailRequest;
      reader.readMessage(value,proto.openbank.v1.admin.UpdateContactDetailRequest.deserializeBinaryFromReader);
      msg.setAuthorizedsignatory(value);
      break;
    case 21:
      var value = /** @type {!proto.identity.OrgType} */ (reader.readEnum());
      msg.setOrgtype(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceofestablishment(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofestablishment(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasphysicalstore(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyprofile(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubindustry(value);
      break;
    case 27:
      var value = /** @type {!proto.identity.Agreement} */ (reader.readEnum());
      msg.setAgreement(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateCompanyInformationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getWebsite();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBusinesstype();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getNoemployees();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getTransactionspermonth();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getFinancepic();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.openbank.v1.admin.UpdateContactDetailRequest.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizedsignatory();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.openbank.v1.admin.UpdateContactDetailRequest.serializeBinaryToWriter
    );
  }
  f = message.getOrgtype();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
  f = message.getPlaceofestablishment();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDateofestablishment();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getHasphysicalstore();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getCompanyprofile();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getSubindustry();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getAgreement();
  if (f !== 0.0) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
};


/**
 * optional string Name = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PhoneNumber = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string TaxIdentificationNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AddressLine1 = 5;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AddressLine2 = 6;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string City = 7;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string PostalCode = 8;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Website = 9;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getWebsite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setWebsite = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Region = 10;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string Country = 11;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string BusinessType = 12;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getBusinesstype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setBusinesstype = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string Role = 13;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Industry = 14;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string NoEmployees = 15;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getNoemployees = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setNoemployees = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string TransactionsPerMonth = 16;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getTransactionspermonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setTransactionspermonth = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string OrgID = 18;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional UpdateContactDetailRequest FinancePIC = 19;
 * @return {?proto.openbank.v1.admin.UpdateContactDetailRequest}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getFinancepic = function() {
  return /** @type{?proto.openbank.v1.admin.UpdateContactDetailRequest} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.UpdateContactDetailRequest, 19));
};


/**
 * @param {?proto.openbank.v1.admin.UpdateContactDetailRequest|undefined} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
*/
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setFinancepic = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.clearFinancepic = function() {
  return this.setFinancepic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.hasFinancepic = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional UpdateContactDetailRequest AuthorizedSignatory = 20;
 * @return {?proto.openbank.v1.admin.UpdateContactDetailRequest}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getAuthorizedsignatory = function() {
  return /** @type{?proto.openbank.v1.admin.UpdateContactDetailRequest} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.UpdateContactDetailRequest, 20));
};


/**
 * @param {?proto.openbank.v1.admin.UpdateContactDetailRequest|undefined} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
*/
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setAuthorizedsignatory = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.clearAuthorizedsignatory = function() {
  return this.setAuthorizedsignatory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.hasAuthorizedsignatory = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional identity.OrgType OrgType = 21;
 * @return {!proto.identity.OrgType}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getOrgtype = function() {
  return /** @type {!proto.identity.OrgType} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.identity.OrgType} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setOrgtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};


/**
 * optional string PlaceOfEstablishment = 22;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getPlaceofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setPlaceofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string DateOfEstablishment = 23;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getDateofestablishment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setDateofestablishment = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional bool HasPhysicalStore = 24;
 * @return {boolean}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getHasphysicalstore = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setHasphysicalstore = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string CompanyProfile = 25;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getCompanyprofile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setCompanyprofile = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string SubIndustry = 26;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getSubindustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setSubindustry = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional identity.Agreement Agreement = 27;
 * @return {!proto.identity.Agreement}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getAgreement = function() {
  return /** @type {!proto.identity.Agreement} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.identity.Agreement} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setAgreement = function(value) {
  return jspb.Message.setProto3EnumField(this, 27, value);
};


/**
 * optional string PhoneNumberCountryCode = 28;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateCompanyInformationRequest.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateContactDetailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateContactDetailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fullname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    role: jspb.Message.getFieldWithDefault(msg, 2, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateContactDetailRequest;
  return proto.openbank.v1.admin.UpdateContactDetailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateContactDetailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateContactDetailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateContactDetailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string FullName = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest} returns this
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Role = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest} returns this
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string PhoneNumber = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest} returns this
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Email = 4;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest} returns this
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string PhoneNumberCountryCode = 5;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateContactDetailRequest} returns this
 */
proto.openbank.v1.admin.UpdateContactDetailRequest.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateCompanyInformationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationResponse}
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateCompanyInformationResponse;
  return proto.openbank.v1.admin.UpdateCompanyInformationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateCompanyInformationResponse}
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateCompanyInformationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateCompanyInformationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateCompanyInformationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ClientDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ClientDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ClientDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ClientDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    usecase: jspb.Message.getFieldWithDefault(msg, 4, ""),
    fileurl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    permataid: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.ClientDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ClientDocument;
  return proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ClientDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsecase(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileurl(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermataid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ClientDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ClientDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsecase();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFileurl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPermataid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string FileName = 3;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string UseCase = 4;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getUsecase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setUsecase = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string FileURL = 5;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getFileurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setFileurl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp Created = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
*/
proto.openbank.v1.admin.ClientDocument.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ClientDocument.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string PermataID = 7;
 * @return {string}
 */
proto.openbank.v1.admin.ClientDocument.prototype.getPermataid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ClientDocument} returns this
 */
proto.openbank.v1.admin.ClientDocument.prototype.setPermataid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetClientDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetClientDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientdocumentsList: jspb.Message.toObjectList(msg.getClientdocumentsList(),
    proto.openbank.v1.admin.ClientDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetClientDocumentsResponse}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetClientDocumentsResponse;
  return proto.openbank.v1.admin.GetClientDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetClientDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetClientDocumentsResponse}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.ClientDocument;
      reader.readMessage(value,proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader);
      msg.addClientdocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetClientDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetClientDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientdocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClientDocument ClientDocuments = 1;
 * @return {!Array<!proto.openbank.v1.admin.ClientDocument>}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.getClientdocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ClientDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ClientDocument, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ClientDocument>} value
 * @return {!proto.openbank.v1.admin.GetClientDocumentsResponse} returns this
*/
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.setClientdocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.ClientDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.addClientdocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.ClientDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetClientDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetClientDocumentsResponse.prototype.clearClientdocumentsList = function() {
  return this.setClientdocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RejectKYCApplicationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RejectKYCApplicationRequest}
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RejectKYCApplicationRequest;
  return proto.openbank.v1.admin.RejectKYCApplicationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RejectKYCApplicationRequest}
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RejectKYCApplicationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.RejectKYCApplicationRequest} returns this
 */
proto.openbank.v1.admin.RejectKYCApplicationRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RejectKYCApplicationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RejectKYCApplicationResponse}
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RejectKYCApplicationResponse;
  return proto.openbank.v1.admin.RejectKYCApplicationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RejectKYCApplicationResponse}
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RejectKYCApplicationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RejectKYCApplicationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RejectKYCApplicationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankcode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    apikey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    senderaccountnumber: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpsertPayerFICredentialsRequest;
  return proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderaccountnumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getApikey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSenderaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional fastcheckout.BankCode BankCode = 1;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} returns this
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string ApiKey = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} returns this
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.setApikey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string SenderAccountNumber = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.getSenderaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsRequest} returns this
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsRequest.prototype.setSenderaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsResponse}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpsertPayerFICredentialsResponse;
  return proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpsertPayerFICredentialsResponse}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpsertPayerFICredentialsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpsertPayerFICredentialsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest}
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetBusinessOwnerInformationRequest;
  return proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest}
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.GetBusinessOwnerInformationRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.BusinessOwner.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.BusinessOwner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.BusinessOwner.toObject = function(includeInstance, msg) {
  var f, obj = {
    fullname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    placeofbirth: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateofbirth: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 4, ""),
    occupation: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    email: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isuscitizen: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    citizenship: jspb.Message.getFieldWithDefault(msg, 9, ""),
    currentaddressline1: jspb.Message.getFieldWithDefault(msg, 10, ""),
    currentaddressline2: jspb.Message.getFieldWithDefault(msg, 11, ""),
    currentcountry: jspb.Message.getFieldWithDefault(msg, 12, ""),
    currentregion: jspb.Message.getFieldWithDefault(msg, 13, ""),
    currentcity: jspb.Message.getFieldWithDefault(msg, 14, ""),
    currentzipcode: jspb.Message.getFieldWithDefault(msg, 15, ""),
    registeredaddressline1: jspb.Message.getFieldWithDefault(msg, 16, ""),
    registeredaddressline2: jspb.Message.getFieldWithDefault(msg, 17, ""),
    registeredcountry: jspb.Message.getFieldWithDefault(msg, 18, ""),
    registeredregion: jspb.Message.getFieldWithDefault(msg, 19, ""),
    registeredcity: jspb.Message.getFieldWithDefault(msg, 20, ""),
    registeredzipcode: jspb.Message.getFieldWithDefault(msg, 21, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 22, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 23, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.BusinessOwner}
 */
proto.openbank.v1.admin.BusinessOwner.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.BusinessOwner;
  return proto.openbank.v1.admin.BusinessOwner.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.BusinessOwner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.BusinessOwner}
 */
proto.openbank.v1.admin.BusinessOwner.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceofbirth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofbirth(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGender(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsuscitizen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitizenship(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentaddressline1(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentaddressline2(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentcountry(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentregion(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentcity(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentzipcode(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredaddressline1(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredaddressline2(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredcountry(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredregion(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredcity(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredzipcode(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.BusinessOwner.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.BusinessOwner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.BusinessOwner.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlaceofbirth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateofbirth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGender();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsuscitizen();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCitizenship();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCurrentaddressline1();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCurrentaddressline2();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCurrentcountry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCurrentregion();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCurrentcity();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCurrentzipcode();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRegisteredaddressline1();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRegisteredaddressline2();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getRegisteredcountry();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getRegisteredregion();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getRegisteredcity();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRegisteredzipcode();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string FullName = 1;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PlaceOfBirth = 2;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getPlaceofbirth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setPlaceofbirth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string DateOfBirth = 3;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getDateofbirth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setDateofbirth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Gender = 4;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setGender = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Occupation = 5;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string PhoneNumber = 6;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Email = 7;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool IsUSCitizen = 8;
 * @return {boolean}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getIsuscitizen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setIsuscitizen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string Citizenship = 9;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCitizenship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCitizenship = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CurrentAddressLine1 = 10;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentaddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentaddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CurrentAddressLine2 = 11;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentaddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentaddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CurrentCountry = 12;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentcountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentcountry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string CurrentRegion = 13;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentregion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentregion = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string CurrentCity = 14;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentcity = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string CurrentZipCode = 15;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getCurrentzipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setCurrentzipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string RegisteredAddressLine1 = 16;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredaddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredaddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string RegisteredAddressLine2 = 17;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredaddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredaddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string RegisteredCountry = 18;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredcountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredcountry = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string RegisteredRegion = 19;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredregion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredregion = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string RegisteredCity = 20;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredcity = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string RegisteredZipCode = 21;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getRegisteredzipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setRegisteredzipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string TaxIdentificationNumber = 22;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string OrgID = 23;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string PhoneNumberCountryCode = 24;
 * @return {string}
 */
proto.openbank.v1.admin.BusinessOwner.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.BusinessOwner} returns this
 */
proto.openbank.v1.admin.BusinessOwner.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateFIServiceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateFIServiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    apikey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    senderaccountnumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    acquiringbin: jspb.Message.getFieldWithDefault(msg, 4, ""),
    payerbankcode: jspb.Message.getFieldWithDefault(msg, 5, 0),
    merchantbankcode: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateFIServiceRequest;
  return proto.openbank.v1.admin.UpdateFIServiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateFIServiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderaccountnumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAcquiringbin(value);
      break;
    case 5:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setPayerbankcode(value);
      break;
    case 6:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setMerchantbankcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateFIServiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateFIServiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApikey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSenderaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAcquiringbin();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPayerbankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getMerchantbankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ApiKey = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setApikey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string SenderAccountNumber = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getSenderaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setSenderaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AcquiringBin = 4;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getAcquiringbin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setAcquiringbin = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional fastcheckout.BankCode PayerBankCode = 5;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getPayerbankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setPayerbankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional fastcheckout.DestinationBankCode MerchantBankCode = 6;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.getMerchantbankcode = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.openbank.v1.admin.UpdateFIServiceRequest} returns this
 */
proto.openbank.v1.admin.UpdateFIServiceRequest.prototype.setMerchantbankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateFIServiceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateFIServiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateFIServiceResponse}
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateFIServiceResponse;
  return proto.openbank.v1.admin.UpdateFIServiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateFIServiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateFIServiceResponse}
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateFIServiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateFIServiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateFIServiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.KYCDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.KYCDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.KYCDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    remarks: jspb.Message.getFieldWithDefault(msg, 2, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    title: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.KYCDocument}
 */
proto.openbank.v1.admin.KYCDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.KYCDocument;
  return proto.openbank.v1.admin.KYCDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.KYCDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.KYCDocument}
 */
proto.openbank.v1.admin.KYCDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemarks(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.KYCDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.KYCDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.KYCDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRemarks();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocument.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocument} returns this
 */
proto.openbank.v1.admin.KYCDocument.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Remarks = 2;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocument.prototype.getRemarks = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocument} returns this
 */
proto.openbank.v1.admin.KYCDocument.prototype.setRemarks = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string FileName = 3;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocument.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocument} returns this
 */
proto.openbank.v1.admin.KYCDocument.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Name = 4;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocument.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocument} returns this
 */
proto.openbank.v1.admin.KYCDocument.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Title = 5;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocument.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocument} returns this
 */
proto.openbank.v1.admin.KYCDocument.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.KYCDocumentReview.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.KYCDocumentReview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.KYCDocumentReview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReview.toObject = function(includeInstance, msg) {
  var f, obj = {
    documenttype: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.openbank.v1.admin.KYCDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.KYCDocumentReview}
 */
proto.openbank.v1.admin.KYCDocumentReview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.KYCDocumentReview;
  return proto.openbank.v1.admin.KYCDocumentReview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.KYCDocumentReview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.KYCDocumentReview}
 */
proto.openbank.v1.admin.KYCDocumentReview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumenttype(value);
      break;
    case 2:
      var value = new proto.openbank.v1.admin.KYCDocument;
      reader.readMessage(value,proto.openbank.v1.admin.KYCDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.KYCDocumentReview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.KYCDocumentReview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumenttype();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.openbank.v1.admin.KYCDocument.serializeBinaryToWriter
    );
  }
};


/**
 * optional string DocumentType = 1;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.getDocumenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocumentReview} returns this
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated KYCDocument Documents = 2;
 * @return {!Array<!proto.openbank.v1.admin.KYCDocument>}
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.KYCDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.KYCDocument, 2));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.KYCDocument>} value
 * @return {!proto.openbank.v1.admin.KYCDocumentReview} returns this
*/
proto.openbank.v1.admin.KYCDocumentReview.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.openbank.v1.admin.KYCDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.KYCDocument}
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.openbank.v1.admin.KYCDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.KYCDocumentReview} returns this
 */
proto.openbank.v1.admin.KYCDocumentReview.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.KYCDocumentReviewRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    kycdocumentsList: jspb.Message.toObjectList(msg.getKycdocumentsList(),
    proto.openbank.v1.admin.KYCDocumentReview.toObject, includeInstance),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewRequest}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.KYCDocumentReviewRequest;
  return proto.openbank.v1.admin.KYCDocumentReviewRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewRequest}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.KYCDocumentReview;
      reader.readMessage(value,proto.openbank.v1.admin.KYCDocumentReview.deserializeBinaryFromReader);
      msg.addKycdocuments(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.KYCDocumentReviewRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKycdocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.KYCDocumentReview.serializeBinaryToWriter
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated KYCDocumentReview KYCDocuments = 1;
 * @return {!Array<!proto.openbank.v1.admin.KYCDocumentReview>}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.getKycdocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.KYCDocumentReview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.KYCDocumentReview, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.KYCDocumentReview>} value
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewRequest} returns this
*/
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.setKycdocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.KYCDocumentReview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.KYCDocumentReview}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.addKycdocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.KYCDocumentReview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewRequest} returns this
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.clearKycdocumentsList = function() {
  return this.setKycdocumentsList([]);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewRequest} returns this
 */
proto.openbank.v1.admin.KYCDocumentReviewRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.KYCDocumentReviewResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewResponse}
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.KYCDocumentReviewResponse;
  return proto.openbank.v1.admin.KYCDocumentReviewResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.KYCDocumentReviewResponse}
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.KYCDocumentReviewResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.KYCDocumentReviewResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.KYCDocumentReviewResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetSupportingDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    country: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orgtype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    domiciletype: jspb.Message.getFieldWithDefault(msg, 4, 0),
    documenttype: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetSupportingDocumentsRequest;
  return proto.openbank.v1.admin.GetSupportingDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.OrgType} */ (reader.readEnum());
      msg.setOrgtype(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.DomicileType} */ (reader.readEnum());
      msg.setDomiciletype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumenttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetSupportingDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrgtype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDomiciletype();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDocumenttype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Country = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional identity.OrgType OrgType = 3;
 * @return {!proto.identity.OrgType}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.getOrgtype = function() {
  return /** @type {!proto.identity.OrgType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.OrgType} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.setOrgtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional identity.DomicileType DomicileType = 4;
 * @return {!proto.identity.DomicileType}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.getDomiciletype = function() {
  return /** @type {!proto.identity.DomicileType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.DomicileType} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.setDomiciletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string DocumentType = 5;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.getDocumenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsRequest.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetSupportingDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentidnumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orgdocumentsList: jspb.Message.toObjectList(msg.getOrgdocumentsList(),
    proto.openbank.v1.admin.ClientDocument.toObject, includeInstance),
    isshareholder: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    iscompanydirectors: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    documenttype: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetSupportingDocumentsResponse;
  return proto.openbank.v1.admin.GetSupportingDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentidnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 3:
      var value = new proto.openbank.v1.admin.ClientDocument;
      reader.readMessage(value,proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader);
      msg.addOrgdocuments(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsshareholder(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscompanydirectors(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumenttype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetSupportingDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentidnumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrgdocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter
    );
  }
  f = message.getIsshareholder();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIscompanydirectors();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getDocumenttype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string DocumentIdNumber = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getDocumentidnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setDocumentidnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string TaxIdentificationNumber = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ClientDocument OrgDocuments = 3;
 * @return {!Array<!proto.openbank.v1.admin.ClientDocument>}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getOrgdocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ClientDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ClientDocument, 3));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ClientDocument>} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
*/
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setOrgdocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.openbank.v1.admin.ClientDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.addOrgdocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.openbank.v1.admin.ClientDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.clearOrgdocumentsList = function() {
  return this.setOrgdocumentsList([]);
};


/**
 * optional bool IsShareholder = 4;
 * @return {boolean}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getIsshareholder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setIsshareholder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool IsCompanyDirectors = 5;
 * @return {boolean}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getIscompanydirectors = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setIscompanydirectors = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string DocumentType = 6;
 * @return {string}
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.getDocumenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetSupportingDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetSupportingDocumentsResponse.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetFinancePICRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetFinancePICRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetFinancePICRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetFinancePICRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetFinancePICRequest}
 */
proto.openbank.v1.admin.GetFinancePICRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetFinancePICRequest;
  return proto.openbank.v1.admin.GetFinancePICRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetFinancePICRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetFinancePICRequest}
 */
proto.openbank.v1.admin.GetFinancePICRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetFinancePICRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetFinancePICRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetFinancePICRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetFinancePICRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetFinancePICRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetFinancePICRequest} returns this
 */
proto.openbank.v1.admin.GetFinancePICRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.FinancePIC.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.FinancePIC.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.FinancePIC} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.FinancePIC.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    directorofcompany: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    powerofattorneyfileid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    identificationdocumentfileid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    picindex: jspb.Message.getFieldWithDefault(msg, 9, 0),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.FinancePIC}
 */
proto.openbank.v1.admin.FinancePIC.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.FinancePIC;
  return proto.openbank.v1.admin.FinancePIC.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.FinancePIC} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.FinancePIC}
 */
proto.openbank.v1.admin.FinancePIC.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDirectorofcompany(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPowerofattorneyfileid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationdocumentfileid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPicindex(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.FinancePIC.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.FinancePIC.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.FinancePIC} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.FinancePIC.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDirectorofcompany();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getPowerofattorneyfileid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIdentificationdocumentfileid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPicindex();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string Id = 1;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FullName = 2;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Role = 3;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PhoneNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Email = 5;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool DirectorOfCompany = 6;
 * @return {boolean}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getDirectorofcompany = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setDirectorofcompany = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string PowerOfAttorneyFileId = 7;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getPowerofattorneyfileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setPowerofattorneyfileid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string IdentificationDocumentFileId = 8;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getIdentificationdocumentfileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setIdentificationdocumentfileid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 PicIndex = 9;
 * @return {number}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getPicindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setPicindex = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string PhoneNumberCountryCode = 10;
 * @return {string}
 */
proto.openbank.v1.admin.FinancePIC.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.FinancePIC} returns this
 */
proto.openbank.v1.admin.FinancePIC.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.OrgDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.OrgDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.OrgDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.OrgDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    usecase: jspb.Message.getFieldWithDefault(msg, 3, ""),
    signedurl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    picindex: jspb.Message.getFieldWithDefault(msg, 5, 0),
    orgid: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.OrgDocument}
 */
proto.openbank.v1.admin.OrgDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.OrgDocument;
  return proto.openbank.v1.admin.OrgDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.OrgDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.OrgDocument}
 */
proto.openbank.v1.admin.OrgDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsecase(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignedurl(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPicindex(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.OrgDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.OrgDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.OrgDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.OrgDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUsecase();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSignedurl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPicindex();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FileName = 2;
 * @return {string}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string UseCase = 3;
 * @return {string}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getUsecase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setUsecase = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string SignedURL = 4;
 * @return {string}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getSignedurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setSignedurl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 PicIndex = 5;
 * @return {number}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getPicindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setPicindex = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string OrgID = 6;
 * @return {string}
 */
proto.openbank.v1.admin.OrgDocument.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.OrgDocument} returns this
 */
proto.openbank.v1.admin.OrgDocument.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetFinancePICResponse.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetFinancePICResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetFinancePICResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetFinancePICResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingpicsList: jspb.Message.toObjectList(msg.getBillingpicsList(),
    proto.openbank.v1.admin.FinancePIC.toObject, includeInstance),
    authorizedsignatoriesList: jspb.Message.toObjectList(msg.getAuthorizedsignatoriesList(),
    proto.openbank.v1.admin.FinancePIC.toObject, includeInstance),
    picdocumentsList: jspb.Message.toObjectList(msg.getPicdocumentsList(),
    proto.openbank.v1.admin.OrgDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse}
 */
proto.openbank.v1.admin.GetFinancePICResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetFinancePICResponse;
  return proto.openbank.v1.admin.GetFinancePICResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetFinancePICResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse}
 */
proto.openbank.v1.admin.GetFinancePICResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.FinancePIC;
      reader.readMessage(value,proto.openbank.v1.admin.FinancePIC.deserializeBinaryFromReader);
      msg.addBillingpics(value);
      break;
    case 2:
      var value = new proto.openbank.v1.admin.FinancePIC;
      reader.readMessage(value,proto.openbank.v1.admin.FinancePIC.deserializeBinaryFromReader);
      msg.addAuthorizedsignatories(value);
      break;
    case 3:
      var value = new proto.openbank.v1.admin.OrgDocument;
      reader.readMessage(value,proto.openbank.v1.admin.OrgDocument.deserializeBinaryFromReader);
      msg.addPicdocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetFinancePICResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetFinancePICResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetFinancePICResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingpicsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.FinancePIC.serializeBinaryToWriter
    );
  }
  f = message.getAuthorizedsignatoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.openbank.v1.admin.FinancePIC.serializeBinaryToWriter
    );
  }
  f = message.getPicdocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.openbank.v1.admin.OrgDocument.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FinancePIC BillingPICs = 1;
 * @return {!Array<!proto.openbank.v1.admin.FinancePIC>}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.getBillingpicsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.FinancePIC>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.FinancePIC, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.FinancePIC>} value
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
*/
proto.openbank.v1.admin.GetFinancePICResponse.prototype.setBillingpicsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.FinancePIC=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.FinancePIC}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.addBillingpics = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.FinancePIC, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.clearBillingpicsList = function() {
  return this.setBillingpicsList([]);
};


/**
 * repeated FinancePIC AuthorizedSignatories = 2;
 * @return {!Array<!proto.openbank.v1.admin.FinancePIC>}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.getAuthorizedsignatoriesList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.FinancePIC>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.FinancePIC, 2));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.FinancePIC>} value
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
*/
proto.openbank.v1.admin.GetFinancePICResponse.prototype.setAuthorizedsignatoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.openbank.v1.admin.FinancePIC=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.FinancePIC}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.addAuthorizedsignatories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.openbank.v1.admin.FinancePIC, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.clearAuthorizedsignatoriesList = function() {
  return this.setAuthorizedsignatoriesList([]);
};


/**
 * repeated OrgDocument PICDocuments = 3;
 * @return {!Array<!proto.openbank.v1.admin.OrgDocument>}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.getPicdocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.OrgDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.OrgDocument, 3));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.OrgDocument>} value
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
*/
proto.openbank.v1.admin.GetFinancePICResponse.prototype.setPicdocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.openbank.v1.admin.OrgDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.OrgDocument}
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.addPicdocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.openbank.v1.admin.OrgDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetFinancePICResponse} returns this
 */
proto.openbank.v1.admin.GetFinancePICResponse.prototype.clearPicdocumentsList = function() {
  return this.setPicdocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPayerFICredentialsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankcode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsRequest}
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPayerFICredentialsRequest;
  return proto.openbank.v1.admin.GetPayerFICredentialsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsRequest}
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPayerFICredentialsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional fastcheckout.BankCode BankCode = 1;
 * @return {!proto.fastcheckout.BankCode}
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.BankCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.BankCode} value
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsRequest} returns this
 */
proto.openbank.v1.admin.GetPayerFICredentialsRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPayerFICredentialsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    apikey: jspb.Message.getFieldWithDefault(msg, 1, ""),
    senderaccountnumber: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsResponse}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPayerFICredentialsResponse;
  return proto.openbank.v1.admin.GetPayerFICredentialsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsResponse}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApikey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderaccountnumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPayerFICredentialsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPayerFICredentialsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApikey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSenderaccountnumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ApiKey = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.getApikey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsResponse} returns this
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.setApikey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string SenderAccountNumber = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.getSenderaccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPayerFICredentialsResponse} returns this
 */
proto.openbank.v1.admin.GetPayerFICredentialsResponse.prototype.setSenderaccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetMerchantFICredentialsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    bankcode: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetMerchantFICredentialsRequest;
  return proto.openbank.v1.admin.GetMerchantFICredentialsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fastcheckout.DestinationBankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetMerchantFICredentialsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional fastcheckout.DestinationBankCode BankCode = 1;
 * @return {!proto.fastcheckout.DestinationBankCode}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.prototype.getBankcode = function() {
  return /** @type {!proto.fastcheckout.DestinationBankCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fastcheckout.DestinationBankCode} value
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsRequest} returns this
 */
proto.openbank.v1.admin.GetMerchantFICredentialsRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetMerchantFICredentialsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    acquiringbin: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetMerchantFICredentialsResponse;
  return proto.openbank.v1.admin.GetMerchantFICredentialsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAcquiringbin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetMerchantFICredentialsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAcquiringbin();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string AcquiringBin = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.prototype.getAcquiringbin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetMerchantFICredentialsResponse} returns this
 */
proto.openbank.v1.admin.GetMerchantFICredentialsResponse.prototype.setAcquiringbin = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fullname: jspb.Message.getFieldWithDefault(msg, 1, ""),
    placeofbirth: jspb.Message.getFieldWithDefault(msg, 2, ""),
    dateofbirth: jspb.Message.getFieldWithDefault(msg, 3, ""),
    gender: jspb.Message.getFieldWithDefault(msg, 4, ""),
    occupation: jspb.Message.getFieldWithDefault(msg, 5, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
    email: jspb.Message.getFieldWithDefault(msg, 7, ""),
    isuscitizen: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    citizenship: jspb.Message.getFieldWithDefault(msg, 9, ""),
    currentaddressline1: jspb.Message.getFieldWithDefault(msg, 10, ""),
    currentaddressline2: jspb.Message.getFieldWithDefault(msg, 11, ""),
    currentcountry: jspb.Message.getFieldWithDefault(msg, 12, ""),
    currentregion: jspb.Message.getFieldWithDefault(msg, 13, ""),
    currentcity: jspb.Message.getFieldWithDefault(msg, 14, ""),
    currentzipcode: jspb.Message.getFieldWithDefault(msg, 15, ""),
    registeredaddressline1: jspb.Message.getFieldWithDefault(msg, 16, ""),
    registeredaddressline2: jspb.Message.getFieldWithDefault(msg, 17, ""),
    registeredcountry: jspb.Message.getFieldWithDefault(msg, 18, ""),
    registeredregion: jspb.Message.getFieldWithDefault(msg, 19, ""),
    registeredcity: jspb.Message.getFieldWithDefault(msg, 20, ""),
    registeredzipcode: jspb.Message.getFieldWithDefault(msg, 21, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 22, ""),
    domiciletype: jspb.Message.getFieldWithDefault(msg, 23, 0),
    orgid: jspb.Message.getFieldWithDefault(msg, 24, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 26, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest;
  return proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaceofbirth(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateofbirth(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGender(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOccupation(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsuscitizen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitizenship(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentaddressline1(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentaddressline2(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentcountry(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentregion(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentcity(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentzipcode(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredaddressline1(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredaddressline2(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredcountry(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredregion(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredcity(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegisteredzipcode(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 23:
      var value = /** @type {!proto.identity.DomicileType} */ (reader.readEnum());
      msg.setDomiciletype(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlaceofbirth();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDateofbirth();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getGender();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOccupation();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIsuscitizen();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCitizenship();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCurrentaddressline1();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCurrentaddressline2();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCurrentcountry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCurrentregion();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCurrentcity();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCurrentzipcode();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRegisteredaddressline1();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getRegisteredaddressline2();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getRegisteredcountry();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getRegisteredregion();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getRegisteredcity();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getRegisteredzipcode();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getDomiciletype();
  if (f !== 0.0) {
    writer.writeEnum(
      23,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
};


/**
 * optional string FullName = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PlaceOfBirth = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getPlaceofbirth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setPlaceofbirth = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string DateOfBirth = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getDateofbirth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setDateofbirth = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Gender = 4;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getGender = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setGender = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Occupation = 5;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getOccupation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setOccupation = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string PhoneNumber = 6;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string Email = 7;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool IsUSCitizen = 8;
 * @return {boolean}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getIsuscitizen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setIsuscitizen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string Citizenship = 9;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCitizenship = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCitizenship = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string CurrentAddressLine1 = 10;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentaddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentaddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string CurrentAddressLine2 = 11;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentaddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentaddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string CurrentCountry = 12;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentcountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentcountry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string CurrentRegion = 13;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentregion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentregion = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string CurrentCity = 14;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentcity = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string CurrentZipCode = 15;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getCurrentzipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setCurrentzipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string RegisteredAddressLine1 = 16;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredaddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredaddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string RegisteredAddressLine2 = 17;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredaddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredaddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string RegisteredCountry = 18;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredcountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredcountry = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string RegisteredRegion = 19;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredregion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredregion = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string RegisteredCity = 20;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredcity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredcity = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string RegisteredZipCode = 21;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getRegisteredzipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setRegisteredzipcode = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string TaxIdentificationNumber = 22;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional identity.DomicileType DomicileType = 23;
 * @return {!proto.identity.DomicileType}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getDomiciletype = function() {
  return /** @type {!proto.identity.DomicileType} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {!proto.identity.DomicileType} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setDomiciletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 23, value);
};


/**
 * optional string OrgID = 24;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string PhoneNumberCountryCode = 26;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest} returns this
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationRequest.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse;
  return proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateBusinessOwnerInformationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SubmitFinancePICRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SubmitFinancePICRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fullname: jspb.Message.getFieldWithDefault(msg, 2, ""),
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    email: jspb.Message.getFieldWithDefault(msg, 5, ""),
    roletype: jspb.Message.getFieldWithDefault(msg, 6, 0),
    powerofattorneyfileid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    identificationdocumentfileid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    directorofcompany: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    domiciletype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    picindex: jspb.Message.getFieldWithDefault(msg, 11, 0),
    orgid: jspb.Message.getFieldWithDefault(msg, 12, ""),
    phonenumbercountrycode: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SubmitFinancePICRequest;
  return proto.openbank.v1.admin.SubmitFinancePICRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SubmitFinancePICRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFullname(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 6:
      var value = /** @type {!proto.identity.PICType} */ (reader.readEnum());
      msg.setRoletype(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPowerofattorneyfileid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdentificationdocumentfileid(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDirectorofcompany(value);
      break;
    case 10:
      var value = /** @type {!proto.identity.DomicileType} */ (reader.readEnum());
      msg.setDomiciletype(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPicindex(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumbercountrycode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SubmitFinancePICRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SubmitFinancePICRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFullname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRoletype();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPowerofattorneyfileid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIdentificationdocumentfileid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDirectorofcompany();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDomiciletype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getPicindex();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPhonenumbercountrycode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FullName = 2;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Role = 3;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string PhoneNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string Email = 5;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional identity.PICType RoleType = 6;
 * @return {!proto.identity.PICType}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getRoletype = function() {
  return /** @type {!proto.identity.PICType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.identity.PICType} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setRoletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string PowerOfAttorneyFileId = 7;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getPowerofattorneyfileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setPowerofattorneyfileid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string IdentificationDocumentFileId = 8;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getIdentificationdocumentfileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setIdentificationdocumentfileid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool DirectorOfCompany = 9;
 * @return {boolean}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getDirectorofcompany = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setDirectorofcompany = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional identity.DomicileType DomicileType = 10;
 * @return {!proto.identity.DomicileType}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getDomiciletype = function() {
  return /** @type {!proto.identity.DomicileType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.identity.DomicileType} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setDomiciletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional int32 PICIndex = 11;
 * @return {number}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getPicindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setPicindex = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string OrgID = 12;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string PhoneNumberCountryCode = 13;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.getPhonenumbercountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICRequest} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICRequest.prototype.setPhonenumbercountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SubmitFinancePICResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SubmitFinancePICResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentsList: jspb.Message.toObjectList(msg.getDocumentsList(),
    proto.openbank.v1.admin.OrgDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SubmitFinancePICResponse}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SubmitFinancePICResponse;
  return proto.openbank.v1.admin.SubmitFinancePICResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SubmitFinancePICResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SubmitFinancePICResponse}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.openbank.v1.admin.OrgDocument;
      reader.readMessage(value,proto.openbank.v1.admin.OrgDocument.deserializeBinaryFromReader);
      msg.addDocuments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SubmitFinancePICResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SubmitFinancePICResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.openbank.v1.admin.OrgDocument.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICResponse} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated OrgDocument Documents = 2;
 * @return {!Array<!proto.openbank.v1.admin.OrgDocument>}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.getDocumentsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.OrgDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.OrgDocument, 2));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.OrgDocument>} value
 * @return {!proto.openbank.v1.admin.SubmitFinancePICResponse} returns this
*/
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.setDocumentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.openbank.v1.admin.OrgDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.OrgDocument}
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.addDocuments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.openbank.v1.admin.OrgDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.SubmitFinancePICResponse} returns this
 */
proto.openbank.v1.admin.SubmitFinancePICResponse.prototype.clearDocumentsList = function() {
  return this.setDocumentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveFinancePICRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveFinancePICRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveFinancePICRequest}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveFinancePICRequest;
  return proto.openbank.v1.admin.RemoveFinancePICRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveFinancePICRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveFinancePICRequest}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveFinancePICRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveFinancePICRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.RemoveFinancePICRequest} returns this
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.RemoveFinancePICRequest} returns this
 */
proto.openbank.v1.admin.RemoveFinancePICRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveFinancePICResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveFinancePICResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveFinancePICResponse}
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveFinancePICResponse;
  return proto.openbank.v1.admin.RemoveFinancePICResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveFinancePICResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveFinancePICResponse}
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveFinancePICResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveFinancePICResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveFinancePICResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    documentnumber: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taxidentificationnumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isshareholder: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    iscompanydirectors: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    documenttype: jspb.Message.getFieldWithDefault(msg, 5, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fileidsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    country: jspb.Message.getFieldWithDefault(msg, 8, ""),
    domiciletype: jspb.Message.getFieldWithDefault(msg, 9, 0),
    orgtype: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SubmitSupportingDocumentsRequest;
  return proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentnumber(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxidentificationnumber(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsshareholder(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIscompanydirectors(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumenttype(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addFileids(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 9:
      var value = /** @type {!proto.identity.DomicileType} */ (reader.readEnum());
      msg.setDomiciletype(value);
      break;
    case 10:
      var value = /** @type {!proto.identity.OrgType} */ (reader.readEnum());
      msg.setOrgtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDocumentnumber();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaxidentificationnumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsshareholder();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIscompanydirectors();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getDocumenttype();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFileidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDomiciletype();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getOrgtype();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional string DocumentNumber = 1;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getDocumentnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setDocumentnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string TaxIdentificationNumber = 2;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getTaxidentificationnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setTaxidentificationnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool IsShareholder = 3;
 * @return {boolean}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getIsshareholder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setIsshareholder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool IsCompanyDirectors = 4;
 * @return {boolean}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getIscompanydirectors = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setIscompanydirectors = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string DocumentType = 5;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getDocumenttype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setDocumenttype = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string OrgID = 6;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated string FileIDs = 7;
 * @return {!Array<string>}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getFileidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setFileidsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.addFileids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.clearFileidsList = function() {
  return this.setFileidsList([]);
};


/**
 * optional string Country = 8;
 * @return {string}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional identity.DomicileType DomicileType = 9;
 * @return {!proto.identity.DomicileType}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getDomiciletype = function() {
  return /** @type {!proto.identity.DomicileType} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.identity.DomicileType} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setDomiciletype = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional identity.OrgType OrgType = 10;
 * @return {!proto.identity.OrgType}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.getOrgtype = function() {
  return /** @type {!proto.identity.OrgType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.identity.OrgType} value
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsRequest} returns this
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsRequest.prototype.setOrgtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsResponse}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.SubmitSupportingDocumentsResponse;
  return proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.SubmitSupportingDocumentsResponse}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.SubmitSupportingDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.SubmitSupportingDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveClientDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveClientDocumentsRequest;
  return proto.openbank.v1.admin.RemoveClientDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFileids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveClientDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} returns this
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string FileIDs = 2;
 * @return {!Array<string>}
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.getFileidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} returns this
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.setFileidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} returns this
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.addFileids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsRequest} returns this
 */
proto.openbank.v1.admin.RemoveClientDocumentsRequest.prototype.clearFileidsList = function() {
  return this.setFileidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveClientDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsResponse}
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveClientDocumentsResponse;
  return proto.openbank.v1.admin.RemoveClientDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveClientDocumentsResponse}
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveClientDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveClientDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveClientDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.PermataCompanyInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.PermataCompanyInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.PermataCompanyInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountholder: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountnumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
    ipaddress: jspb.Message.getFieldWithDefault(msg, 5, ""),
    branchaddress: jspb.Message.getFieldWithDefault(msg, 6, ""),
    activeperiodcatid: jspb.Message.getFieldWithDefault(msg, 7, 0),
    businesslicensefileid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    addressline1: jspb.Message.getFieldWithDefault(msg, 9, ""),
    addressline2: jspb.Message.getFieldWithDefault(msg, 10, ""),
    localityregion: jspb.Message.getFieldWithDefault(msg, 11, ""),
    city: jspb.Message.getFieldWithDefault(msg, 12, ""),
    postalcode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    country: jspb.Message.getFieldWithDefault(msg, 14, ""),
    kycstatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updated: (f = msg.getUpdated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo}
 */
proto.openbank.v1.admin.PermataCompanyInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.PermataCompanyInfo;
  return proto.openbank.v1.admin.PermataCompanyInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.PermataCompanyInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo}
 */
proto.openbank.v1.admin.PermataCompanyInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountholder(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountnumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpaddress(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranchaddress(value);
      break;
    case 7:
      var value = /** @type {!proto.identity.OrgActivePeriod} */ (reader.readEnum());
      msg.setActiveperiodcatid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinesslicensefileid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline1(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressline2(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocalityregion(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPostalcode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 15:
      var value = /** @type {!proto.identity.PartnerKycStatus} */ (reader.readEnum());
      msg.setKycstatus(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.PermataCompanyInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.PermataCompanyInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.PermataCompanyInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountholder();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountnumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIpaddress();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBranchaddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActiveperiodcatid();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getBusinesslicensefileid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressline1();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAddressline2();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLocalityregion();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPostalcode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getKycstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdated();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string AccountHolder = 3;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getAccountholder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setAccountholder = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string AccountNumber = 4;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getAccountnumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setAccountnumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string IPAddress = 5;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getIpaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setIpaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string BranchAddress = 6;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getBranchaddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setBranchaddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional identity.OrgActivePeriod ActivePeriodCatID = 7;
 * @return {!proto.identity.OrgActivePeriod}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getActiveperiodcatid = function() {
  return /** @type {!proto.identity.OrgActivePeriod} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.identity.OrgActivePeriod} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setActiveperiodcatid = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string BusinessLicenseFileID = 8;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getBusinesslicensefileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setBusinesslicensefileid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string AddressLine1 = 9;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getAddressline1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setAddressline1 = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string AddressLine2 = 10;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getAddressline2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setAddressline2 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string LocalityRegion = 11;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getLocalityregion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setLocalityregion = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string City = 12;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string PostalCode = 13;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getPostalcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setPostalcode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string Country = 14;
 * @return {string}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional identity.PartnerKycStatus KYCStatus = 15;
 * @return {!proto.identity.PartnerKycStatus}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getKycstatus = function() {
  return /** @type {!proto.identity.PartnerKycStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.identity.PartnerKycStatus} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setKycstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional google.protobuf.Timestamp Created = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
*/
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.Timestamp Updated = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.getUpdated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
*/
proto.openbank.v1.admin.PermataCompanyInfo.prototype.setUpdated = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.PermataCompanyInfo} returns this
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.clearUpdated = function() {
  return this.setUpdated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.PermataCompanyInfo.prototype.hasUpdated = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPermataCompanyInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    permataid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPermataCompanyInfoRequest;
  return proto.openbank.v1.admin.GetPermataCompanyInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermataid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPermataCompanyInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPermataid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest} returns this
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PermataID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.getPermataid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoRequest} returns this
 */
proto.openbank.v1.admin.GetPermataCompanyInfoRequest.prototype.setPermataid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPermataCompanyInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    infoList: jspb.Message.toObjectList(msg.getInfoList(),
    proto.openbank.v1.admin.PermataCompleteInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPermataCompanyInfoResponse;
  return proto.openbank.v1.admin.GetPermataCompanyInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.PermataCompleteInfo;
      reader.readMessage(value,proto.openbank.v1.admin.PermataCompleteInfo.deserializeBinaryFromReader);
      msg.addInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPermataCompanyInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.PermataCompleteInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PermataCompleteInfo Info = 1;
 * @return {!Array<!proto.openbank.v1.admin.PermataCompleteInfo>}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.getInfoList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.PermataCompleteInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.PermataCompleteInfo, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.PermataCompleteInfo>} value
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse} returns this
*/
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.setInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.PermataCompleteInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo}
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.addInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.PermataCompleteInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetPermataCompanyInfoResponse} returns this
 */
proto.openbank.v1.admin.GetPermataCompanyInfoResponse.prototype.clearInfoList = function() {
  return this.setInfoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.PermataCompleteInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.PermataCompleteInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.PermataCompleteInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.PermataCompleteInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    org: (f = msg.getOrg()) && proto.openbank.v1.admin.PermataCompanyInfo.toObject(includeInstance, f),
    documentList: jspb.Message.toObjectList(msg.getDocumentList(),
    proto.openbank.v1.admin.ClientDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo}
 */
proto.openbank.v1.admin.PermataCompleteInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.PermataCompleteInfo;
  return proto.openbank.v1.admin.PermataCompleteInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.PermataCompleteInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo}
 */
proto.openbank.v1.admin.PermataCompleteInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.PermataCompanyInfo;
      reader.readMessage(value,proto.openbank.v1.admin.PermataCompanyInfo.deserializeBinaryFromReader);
      msg.setOrg(value);
      break;
    case 2:
      var value = new proto.openbank.v1.admin.ClientDocument;
      reader.readMessage(value,proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader);
      msg.addDocument(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.PermataCompleteInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.PermataCompleteInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.PermataCompleteInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.openbank.v1.admin.PermataCompanyInfo.serializeBinaryToWriter
    );
  }
  f = message.getDocumentList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter
    );
  }
};


/**
 * optional PermataCompanyInfo Org = 1;
 * @return {?proto.openbank.v1.admin.PermataCompanyInfo}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.getOrg = function() {
  return /** @type{?proto.openbank.v1.admin.PermataCompanyInfo} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.PermataCompanyInfo, 1));
};


/**
 * @param {?proto.openbank.v1.admin.PermataCompanyInfo|undefined} value
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo} returns this
*/
proto.openbank.v1.admin.PermataCompleteInfo.prototype.setOrg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo} returns this
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.clearOrg = function() {
  return this.setOrg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.hasOrg = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ClientDocument Document = 2;
 * @return {!Array<!proto.openbank.v1.admin.ClientDocument>}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.getDocumentList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ClientDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ClientDocument, 2));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ClientDocument>} value
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo} returns this
*/
proto.openbank.v1.admin.PermataCompleteInfo.prototype.setDocumentList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.openbank.v1.admin.ClientDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.addDocument = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.openbank.v1.admin.ClientDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.PermataCompleteInfo} returns this
 */
proto.openbank.v1.admin.PermataCompleteInfo.prototype.clearDocumentList = function() {
  return this.setDocumentList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPermataDocumentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    permataid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsRequest}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPermataDocumentsRequest;
  return proto.openbank.v1.admin.GetPermataDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsRequest}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPermataid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPermataDocumentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPermataid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string PermataID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.getPermataid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsRequest} returns this
 */
proto.openbank.v1.admin.GetPermataDocumentsRequest.prototype.setPermataid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetPermataDocumentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    zipfilesList: jspb.Message.toObjectList(msg.getZipfilesList(),
    proto.openbank.v1.admin.ClientDocument.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsResponse}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetPermataDocumentsResponse;
  return proto.openbank.v1.admin.GetPermataDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsResponse}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.ClientDocument;
      reader.readMessage(value,proto.openbank.v1.admin.ClientDocument.deserializeBinaryFromReader);
      msg.addZipfiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetPermataDocumentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetPermataDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZipfilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.ClientDocument.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ClientDocument ZipFiles = 1;
 * @return {!Array<!proto.openbank.v1.admin.ClientDocument>}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.getZipfilesList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ClientDocument>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ClientDocument, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ClientDocument>} value
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsResponse} returns this
*/
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.setZipfilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.ClientDocument=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ClientDocument}
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.addZipfiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.ClientDocument, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetPermataDocumentsResponse} returns this
 */
proto.openbank.v1.admin.GetPermataDocumentsResponse.prototype.clearZipfilesList = function() {
  return this.setZipfilesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ActivityLog.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ActivityLog.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ActivityLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ActivityLog.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endpoint: jspb.Message.getFieldWithDefault(msg, 2, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ActivityLog}
 */
proto.openbank.v1.admin.ActivityLog.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ActivityLog;
  return proto.openbank.v1.admin.ActivityLog.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ActivityLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ActivityLog}
 */
proto.openbank.v1.admin.ActivityLog.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoint(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ActivityLog.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ActivityLog.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ActivityLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ActivityLog.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndpoint();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Email = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ActivityLog.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ActivityLog} returns this
 */
proto.openbank.v1.admin.ActivityLog.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Endpoint = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ActivityLog.prototype.getEndpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ActivityLog} returns this
 */
proto.openbank.v1.admin.ActivityLog.prototype.setEndpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp Created = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.ActivityLog.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.ActivityLog} returns this
*/
proto.openbank.v1.admin.ActivityLog.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.ActivityLog} returns this
 */
proto.openbank.v1.admin.ActivityLog.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.ActivityLog.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetUserActivityLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetUserActivityLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    endpoint: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startdate: (f = msg.getStartdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    enddate: (f = msg.getEnddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetUserActivityLogRequest;
  return proto.openbank.v1.admin.GetUserActivityLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetUserActivityLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndpoint(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartdate(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetUserActivityLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetUserActivityLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEndpoint();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartdate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnddate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string Email = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Endpoint = 2;
 * @return {string}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.getEndpoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.setEndpoint = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp StartDate = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.getStartdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
*/
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.setStartdate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.clearStartdate = function() {
  return this.setStartdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.hasStartdate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp EndDate = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.getEnddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
*/
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.setEnddate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogRequest} returns this
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.clearEnddate = function() {
  return this.setEnddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.GetUserActivityLogRequest.prototype.hasEnddate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetUserActivityLogResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetUserActivityLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activitylogsList: jspb.Message.toObjectList(msg.getActivitylogsList(),
    proto.openbank.v1.admin.ActivityLog.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogResponse}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetUserActivityLogResponse;
  return proto.openbank.v1.admin.GetUserActivityLogResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetUserActivityLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogResponse}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.ActivityLog;
      reader.readMessage(value,proto.openbank.v1.admin.ActivityLog.deserializeBinaryFromReader);
      msg.addActivitylogs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetUserActivityLogResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetUserActivityLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivitylogsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.ActivityLog.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityLog ActivityLogs = 1;
 * @return {!Array<!proto.openbank.v1.admin.ActivityLog>}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.getActivitylogsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ActivityLog>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ActivityLog, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ActivityLog>} value
 * @return {!proto.openbank.v1.admin.GetUserActivityLogResponse} returns this
*/
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.setActivitylogsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.ActivityLog=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ActivityLog}
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.addActivitylogs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.ActivityLog, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetUserActivityLogResponse} returns this
 */
proto.openbank.v1.admin.GetUserActivityLogResponse.prototype.clearActivitylogsList = function() {
  return this.setActivitylogsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ListBusinessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ListBusinessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ListBusinessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListBusinessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ListBusinessRequest}
 */
proto.openbank.v1.admin.ListBusinessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ListBusinessRequest;
  return proto.openbank.v1.admin.ListBusinessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ListBusinessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ListBusinessRequest}
 */
proto.openbank.v1.admin.ListBusinessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ListBusinessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ListBusinessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ListBusinessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListBusinessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ListBusinessRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ListBusinessRequest} returns this
 */
proto.openbank.v1.admin.ListBusinessRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.ListBusinessResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ListBusinessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ListBusinessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ListBusinessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListBusinessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    businessesList: jspb.Message.toObjectList(msg.getBusinessesList(),
    brank_as_gunk_identity_identity_all_pb.Business.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ListBusinessResponse}
 */
proto.openbank.v1.admin.ListBusinessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ListBusinessResponse;
  return proto.openbank.v1.admin.ListBusinessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ListBusinessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ListBusinessResponse}
 */
proto.openbank.v1.admin.ListBusinessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new brank_as_gunk_identity_identity_all_pb.Business;
      reader.readMessage(value,brank_as_gunk_identity_identity_all_pb.Business.deserializeBinaryFromReader);
      msg.addBusinesses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ListBusinessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ListBusinessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ListBusinessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListBusinessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBusinessesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      brank_as_gunk_identity_identity_all_pb.Business.serializeBinaryToWriter
    );
  }
};


/**
 * repeated identity.Business Businesses = 1;
 * @return {!Array<!proto.identity.Business>}
 */
proto.openbank.v1.admin.ListBusinessResponse.prototype.getBusinessesList = function() {
  return /** @type{!Array<!proto.identity.Business>} */ (
    jspb.Message.getRepeatedWrapperField(this, brank_as_gunk_identity_identity_all_pb.Business, 1));
};


/**
 * @param {!Array<!proto.identity.Business>} value
 * @return {!proto.openbank.v1.admin.ListBusinessResponse} returns this
*/
proto.openbank.v1.admin.ListBusinessResponse.prototype.setBusinessesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.identity.Business=} opt_value
 * @param {number=} opt_index
 * @return {!proto.identity.Business}
 */
proto.openbank.v1.admin.ListBusinessResponse.prototype.addBusinesses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.identity.Business, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.ListBusinessResponse} returns this
 */
proto.openbank.v1.admin.ListBusinessResponse.prototype.clearBusinessesList = function() {
  return this.setBusinessesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ListUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ListUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    page: jspb.Message.getFieldWithDefault(msg, 4, 0),
    pagesize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ListUsersRequest}
 */
proto.openbank.v1.admin.ListUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ListUsersRequest;
  return proto.openbank.v1.admin.ListUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ListUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ListUsersRequest}
 */
proto.openbank.v1.admin.ListUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPagesize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ListUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ListUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ListUsersRequest} returns this
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string UserID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ListUsersRequest} returns this
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Email = 3;
 * @return {string}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ListUsersRequest} returns this
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 Page = 4;
 * @return {number}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.ListUsersRequest} returns this
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 PageSize = 5;
 * @return {number}
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.ListUsersRequest} returns this
 */
proto.openbank.v1.admin.ListUsersRequest.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UserDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UserDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UserDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UserDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    orgid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    emailsubscription: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    emailverified: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    productcode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    phonenumber: jspb.Message.getFieldWithDefault(msg, 7, ""),
    mobilephonenumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    designation: jspb.Message.getFieldWithDefault(msg, 9, ""),
    country: jspb.Message.getFieldWithDefault(msg, 10, ""),
    blocked: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    countrycode: jspb.Message.getFieldWithDefault(msg, 12, ""),
    isactive: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    id: jspb.Message.getFieldWithDefault(msg, 14, ""),
    lastlogin: (f = msg.getLastlogin()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    role: (f = msg.getRole()) && brank_as_gunk_identity_identity_all_pb.Role.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UserDetail}
 */
proto.openbank.v1.admin.UserDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UserDetail;
  return proto.openbank.v1.admin.UserDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UserDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UserDetail}
 */
proto.openbank.v1.admin.UserDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailsubscription(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEmailverified(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductcode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhonenumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMobilephonenumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDesignation(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocked(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountrycode(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactive(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastlogin(value);
      break;
    case 16:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    case 17:
      var value = new brank_as_gunk_identity_identity_all_pb.Role;
      reader.readMessage(value,brank_as_gunk_identity_identity_all_pb.Role.deserializeBinaryFromReader);
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UserDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UserDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UserDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UserDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmailsubscription();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEmailverified();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getProductcode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPhonenumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMobilephonenumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDesignation();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getBlocked();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getCountrycode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIsactive();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLastlogin();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRole();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      brank_as_gunk_identity_identity_all_pb.Role.serializeBinaryToWriter
    );
  }
};


/**
 * optional string OrgID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Email = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool EmailSubscription = 4;
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.getEmailsubscription = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setEmailsubscription = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool EmailVerified = 5;
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.getEmailverified = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setEmailverified = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string ProductCode = 6;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getProductcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setProductcode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string PhoneNumber = 7;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getPhonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setPhonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string MobilePhoneNumber = 8;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getMobilephonenumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setMobilephonenumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string Designation = 9;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getDesignation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setDesignation = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string Country = 10;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool Blocked = 11;
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.getBlocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setBlocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string CountryCode = 12;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getCountrycode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setCountrycode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool IsActive = 13;
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.getIsactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setIsactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string ID = 14;
 * @return {string}
 */
proto.openbank.v1.admin.UserDetail.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.protobuf.Timestamp LastLogin = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.UserDetail.prototype.getLastlogin = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
*/
proto.openbank.v1.admin.UserDetail.prototype.setLastlogin = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.clearLastlogin = function() {
  return this.setLastlogin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.hasLastlogin = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Timestamp Created = 16;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.UserDetail.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 16));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
*/
proto.openbank.v1.admin.UserDetail.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional identity.Role Role = 17;
 * @return {?proto.identity.Role}
 */
proto.openbank.v1.admin.UserDetail.prototype.getRole = function() {
  return /** @type{?proto.identity.Role} */ (
    jspb.Message.getWrapperField(this, brank_as_gunk_identity_identity_all_pb.Role, 17));
};


/**
 * @param {?proto.identity.Role|undefined} value
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
*/
proto.openbank.v1.admin.UserDetail.prototype.setRole = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UserDetail} returns this
 */
proto.openbank.v1.admin.UserDetail.prototype.clearRole = function() {
  return this.setRole(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UserDetail.prototype.hasRole = function() {
  return jspb.Message.getField(this, 17) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.ListUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ListUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ListUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.openbank.v1.admin.UserDetail.toObject, includeInstance),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ListUsersResponse}
 */
proto.openbank.v1.admin.ListUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ListUsersResponse;
  return proto.openbank.v1.admin.ListUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ListUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ListUsersResponse}
 */
proto.openbank.v1.admin.ListUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.UserDetail;
      reader.readMessage(value,proto.openbank.v1.admin.UserDetail.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ListUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ListUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ListUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.UserDetail.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * repeated UserDetail Users = 1;
 * @return {!Array<!proto.openbank.v1.admin.UserDetail>}
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.UserDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.UserDetail, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.UserDetail>} value
 * @return {!proto.openbank.v1.admin.ListUsersResponse} returns this
*/
proto.openbank.v1.admin.ListUsersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.UserDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.UserDetail}
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.UserDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.ListUsersResponse} returns this
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};


/**
 * optional int32 Total = 2;
 * @return {number}
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.ListUsersResponse} returns this
 */
proto.openbank.v1.admin.ListUsersResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveUserRequest}
 */
proto.openbank.v1.admin.RemoveUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveUserRequest;
  return proto.openbank.v1.admin.RemoveUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveUserRequest}
 */
proto.openbank.v1.admin.RemoveUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string UserID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.RemoveUserRequest.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.RemoveUserRequest} returns this
 */
proto.openbank.v1.admin.RemoveUserRequest.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.RemoveUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.RemoveUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.RemoveUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.RemoveUserResponse}
 */
proto.openbank.v1.admin.RemoveUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.RemoveUserResponse;
  return proto.openbank.v1.admin.RemoveUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.RemoveUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.RemoveUserResponse}
 */
proto.openbank.v1.admin.RemoveUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.RemoveUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.RemoveUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.RemoveUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.RemoveUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.Integration.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.Integration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.Integration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Integration.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    product: jspb.Message.getFieldWithDefault(msg, 2, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 5, 0),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    country: jspb.Message.getFieldWithDefault(msg, 7, ""),
    productstatus: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.Integration}
 */
proto.openbank.v1.admin.Integration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.Integration;
  return proto.openbank.v1.admin.Integration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.Integration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.Integration}
 */
proto.openbank.v1.admin.Integration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 6:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 8:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setProductstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.Integration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.Integration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.Integration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.Integration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string ID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.Integration.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional identity.Product Product = 2;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.Integration.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string Name = 3;
 * @return {string}
 */
proto.openbank.v1.admin.Integration.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string Title = 4;
 * @return {string}
 */
proto.openbank.v1.admin.Integration.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional identity.BankCode BankCode = 5;
 * @return {!proto.identity.BankCode}
 */
proto.openbank.v1.admin.Integration.prototype.getBankcode = function() {
  return /** @type {!proto.identity.BankCode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.BankCode} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional identity.ProductStatus Status = 6;
 * @return {!proto.identity.ProductStatus}
 */
proto.openbank.v1.admin.Integration.prototype.getStatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Country = 7;
 * @return {string}
 */
proto.openbank.v1.admin.Integration.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional identity.ProductStatus ProductStatus = 8;
 * @return {!proto.identity.ProductStatus}
 */
proto.openbank.v1.admin.Integration.prototype.getProductstatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.openbank.v1.admin.Integration} returns this
 */
proto.openbank.v1.admin.Integration.prototype.setProductstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.ProductInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.ProductInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.ProductInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.ProductInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ProductInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    product: jspb.Message.getFieldWithDefault(msg, 1, 0),
    country: jspb.Message.getFieldWithDefault(msg, 2, ""),
    productstatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    integrationsList: jspb.Message.toObjectList(msg.getIntegrationsList(),
    proto.openbank.v1.admin.Integration.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.ProductInfo}
 */
proto.openbank.v1.admin.ProductInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.ProductInfo;
  return proto.openbank.v1.admin.ProductInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.ProductInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.ProductInfo}
 */
proto.openbank.v1.admin.ProductInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setProductstatus(value);
      break;
    case 4:
      var value = new proto.openbank.v1.admin.Integration;
      reader.readMessage(value,proto.openbank.v1.admin.Integration.deserializeBinaryFromReader);
      msg.addIntegrations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.ProductInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.ProductInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.ProductInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.ProductInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIntegrationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.openbank.v1.admin.Integration.serializeBinaryToWriter
    );
  }
};


/**
 * optional identity.Product Product = 1;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.ProductInfo.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.ProductInfo} returns this
 */
proto.openbank.v1.admin.ProductInfo.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string Country = 2;
 * @return {string}
 */
proto.openbank.v1.admin.ProductInfo.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.ProductInfo} returns this
 */
proto.openbank.v1.admin.ProductInfo.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional identity.ProductStatus ProductStatus = 3;
 * @return {!proto.identity.ProductStatus}
 */
proto.openbank.v1.admin.ProductInfo.prototype.getProductstatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.openbank.v1.admin.ProductInfo} returns this
 */
proto.openbank.v1.admin.ProductInfo.prototype.setProductstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated Integration Integrations = 4;
 * @return {!Array<!proto.openbank.v1.admin.Integration>}
 */
proto.openbank.v1.admin.ProductInfo.prototype.getIntegrationsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.Integration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.Integration, 4));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.Integration>} value
 * @return {!proto.openbank.v1.admin.ProductInfo} returns this
*/
proto.openbank.v1.admin.ProductInfo.prototype.setIntegrationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.openbank.v1.admin.Integration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.Integration}
 */
proto.openbank.v1.admin.ProductInfo.prototype.addIntegrations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.openbank.v1.admin.Integration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.ProductInfo} returns this
 */
proto.openbank.v1.admin.ProductInfo.prototype.clearIntegrationsList = function() {
  return this.setIntegrationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetIntegrationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetIntegrationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetIntegrationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    country: jspb.Message.getFieldWithDefault(msg, 1, ""),
    bankcode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    product: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetIntegrationsRequest}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetIntegrationsRequest;
  return proto.openbank.v1.admin.GetIntegrationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetIntegrationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetIntegrationsRequest}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 2:
      var value = /** @type {!proto.identity.BankCode} */ (reader.readEnum());
      msg.setBankcode(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetIntegrationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetIntegrationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetIntegrationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBankcode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string Country = 1;
 * @return {string}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.GetIntegrationsRequest} returns this
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional identity.BankCode BankCode = 2;
 * @return {!proto.identity.BankCode}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.getBankcode = function() {
  return /** @type {!proto.identity.BankCode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.identity.BankCode} value
 * @return {!proto.openbank.v1.admin.GetIntegrationsRequest} returns this
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.setBankcode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional identity.Product Product = 3;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.GetIntegrationsRequest} returns this
 */
proto.openbank.v1.admin.GetIntegrationsRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.openbank.v1.admin.GetIntegrationsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.GetIntegrationsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.GetIntegrationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetIntegrationsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    productsList: jspb.Message.toObjectList(msg.getProductsList(),
    proto.openbank.v1.admin.ProductInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.GetIntegrationsResponse}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.GetIntegrationsResponse;
  return proto.openbank.v1.admin.GetIntegrationsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.GetIntegrationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.GetIntegrationsResponse}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.ProductInfo;
      reader.readMessage(value,proto.openbank.v1.admin.ProductInfo.deserializeBinaryFromReader);
      msg.addProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.GetIntegrationsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.GetIntegrationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.GetIntegrationsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.openbank.v1.admin.ProductInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ProductInfo Products = 1;
 * @return {!Array<!proto.openbank.v1.admin.ProductInfo>}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.getProductsList = function() {
  return /** @type{!Array<!proto.openbank.v1.admin.ProductInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.openbank.v1.admin.ProductInfo, 1));
};


/**
 * @param {!Array<!proto.openbank.v1.admin.ProductInfo>} value
 * @return {!proto.openbank.v1.admin.GetIntegrationsResponse} returns this
*/
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.setProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.openbank.v1.admin.ProductInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.openbank.v1.admin.ProductInfo}
 */
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.addProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.openbank.v1.admin.ProductInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.openbank.v1.admin.GetIntegrationsResponse} returns this
 */
proto.openbank.v1.admin.GetIntegrationsResponse.prototype.clearProductsList = function() {
  return this.setProductsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UpdateIntegrationStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    integrationid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    country: jspb.Message.getFieldWithDefault(msg, 2, ""),
    product: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    productstatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    emailtemplate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    note: jspb.Message.getFieldWithDefault(msg, 7, ""),
    emailtitle: jspb.Message.getFieldWithDefault(msg, 8, ""),
    emailbody: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UpdateIntegrationStatusRequest;
  return proto.openbank.v1.admin.UpdateIntegrationStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntegrationid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 3:
      var value = /** @type {!proto.identity.Product} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 4:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.identity.ProductStatus} */ (reader.readEnum());
      msg.setProductstatus(value);
      break;
    case 6:
      var value = /** @type {!proto.openbank.v1.admin.EmailAdvisoryTemplate} */ (reader.readEnum());
      msg.setEmailtemplate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailtitle(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailbody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UpdateIntegrationStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegrationid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getProductstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getEmailtemplate();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEmailtitle();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getEmailbody();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string IntegrationID = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getIntegrationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setIntegrationid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string Country = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional identity.Product Product = 3;
 * @return {!proto.identity.Product}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getProduct = function() {
  return /** @type {!proto.identity.Product} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.identity.Product} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional identity.ProductStatus Status = 4;
 * @return {!proto.identity.ProductStatus}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional identity.ProductStatus ProductStatus = 5;
 * @return {!proto.identity.ProductStatus}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getProductstatus = function() {
  return /** @type {!proto.identity.ProductStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.identity.ProductStatus} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setProductstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional EmailAdvisoryTemplate EmailTemplate = 6;
 * @return {!proto.openbank.v1.admin.EmailAdvisoryTemplate}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getEmailtemplate = function() {
  return /** @type {!proto.openbank.v1.admin.EmailAdvisoryTemplate} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.openbank.v1.admin.EmailAdvisoryTemplate} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setEmailtemplate = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string Note = 7;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string EmailTitle = 8;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getEmailtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setEmailtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string EmailBody = 9;
 * @return {string}
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.getEmailbody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UpdateIntegrationStatusRequest} returns this
 */
proto.openbank.v1.admin.UpdateIntegrationStatusRequest.prototype.setEmailbody = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.EmptyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.EmptyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.EmptyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.EmptyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.EmptyResponse}
 */
proto.openbank.v1.admin.EmptyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.EmptyResponse;
  return proto.openbank.v1.admin.EmptyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.EmptyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.EmptyResponse}
 */
proto.openbank.v1.admin.EmptyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.EmptyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.EmptyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.EmptyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.EmptyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.AdminLogHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.AdminLogHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.AdminLogHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    orgid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    orgemail: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orgname: jspb.Message.getFieldWithDefault(msg, 4, ""),
    adminemail: jspb.Message.getFieldWithDefault(msg, 5, ""),
    adminname: jspb.Message.getFieldWithDefault(msg, 6, ""),
    islive: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    logtype: jspb.Message.getFieldWithDefault(msg, 8, 0),
    description: jspb.Message.getFieldWithDefault(msg, 9, ""),
    requestbody: jspb.Message.getFieldWithDefault(msg, 10, ""),
    created: (f = msg.getCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.AdminLogHistory}
 */
proto.openbank.v1.admin.AdminLogHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.AdminLogHistory;
  return proto.openbank.v1.admin.AdminLogHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.AdminLogHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.AdminLogHistory}
 */
proto.openbank.v1.admin.AdminLogHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgemail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgname(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminemail(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminname(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIslive(value);
      break;
    case 8:
      var value = /** @type {!proto.openbank.v1.admin.AdminLogType} */ (reader.readEnum());
      msg.setLogtype(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestbody(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.AdminLogHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.AdminLogHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.AdminLogHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrgemail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrgname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAdminemail();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAdminname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIslive();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getLogtype();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRequestbody();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreated();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 ID = 1;
 * @return {number}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string OrgID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string OrgEmail = 3;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getOrgemail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setOrgemail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string OrgName = 4;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getOrgname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setOrgname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string AdminEmail = 5;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getAdminemail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setAdminemail = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string AdminName = 6;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getAdminname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setAdminname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool IsLive = 7;
 * @return {boolean}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getIslive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setIslive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional AdminLogType LogType = 8;
 * @return {!proto.openbank.v1.admin.AdminLogType}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getLogtype = function() {
  return /** @type {!proto.openbank.v1.admin.AdminLogType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.openbank.v1.admin.AdminLogType} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setLogtype = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string Description = 9;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string RequestBody = 10;
 * @return {string}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getRequestbody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.setRequestbody = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp Created = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.getCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
*/
proto.openbank.v1.admin.AdminLogHistory.prototype.setCreated = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.AdminLogHistory} returns this
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.clearCreated = function() {
  return this.setCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.AdminLogHistory.prototype.hasCreated = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UploadFileRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UploadFileRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UploadFileRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    usecase: jspb.Message.getFieldWithDefault(msg, 1, ""),
    filename: jspb.Message.getFieldWithDefault(msg, 2, ""),
    financepicid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filechunk: msg.getFilechunk_asB64(),
    orgid: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UploadFileRequest}
 */
proto.openbank.v1.admin.UploadFileRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UploadFileRequest;
  return proto.openbank.v1.admin.UploadFileRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UploadFileRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UploadFileRequest}
 */
proto.openbank.v1.admin.UploadFileRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsecase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilename(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinancepicid(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFilechunk(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UploadFileRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UploadFileRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UploadFileRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsecase();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilename();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFinancepicid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFilechunk_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getOrgid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string UseCase = 1;
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getUsecase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UploadFileRequest} returns this
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.setUsecase = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string FileName = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getFilename = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UploadFileRequest} returns this
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.setFilename = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string FinancePicID = 3;
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getFinancepicid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UploadFileRequest} returns this
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.setFinancepicid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bytes FileChunk = 4;
 * @return {!(string|Uint8Array)}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getFilechunk = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes FileChunk = 4;
 * This is a type-conversion wrapper around `getFilechunk()`
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getFilechunk_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFilechunk()));
};


/**
 * optional bytes FileChunk = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFilechunk()`
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getFilechunk_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFilechunk()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.openbank.v1.admin.UploadFileRequest} returns this
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.setFilechunk = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional string OrgID = 5;
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.getOrgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UploadFileRequest} returns this
 */
proto.openbank.v1.admin.UploadFileRequest.prototype.setOrgid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.openbank.v1.admin.UploadFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.openbank.v1.admin.UploadFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UploadFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    kycuploadfile: (f = msg.getKycuploadfile()) && proto.openbank.v1.admin.File.toObject(includeInstance, f),
    fileid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.openbank.v1.admin.UploadFileResponse}
 */
proto.openbank.v1.admin.UploadFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.openbank.v1.admin.UploadFileResponse;
  return proto.openbank.v1.admin.UploadFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.openbank.v1.admin.UploadFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.openbank.v1.admin.UploadFileResponse}
 */
proto.openbank.v1.admin.UploadFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.openbank.v1.admin.File;
      reader.readMessage(value,proto.openbank.v1.admin.File.deserializeBinaryFromReader);
      msg.setKycuploadfile(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.openbank.v1.admin.UploadFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.openbank.v1.admin.UploadFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.openbank.v1.admin.UploadFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKycuploadfile();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.openbank.v1.admin.File.serializeBinaryToWriter
    );
  }
  f = message.getFileid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional File KycUploadFile = 1;
 * @return {?proto.openbank.v1.admin.File}
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.getKycuploadfile = function() {
  return /** @type{?proto.openbank.v1.admin.File} */ (
    jspb.Message.getWrapperField(this, proto.openbank.v1.admin.File, 1));
};


/**
 * @param {?proto.openbank.v1.admin.File|undefined} value
 * @return {!proto.openbank.v1.admin.UploadFileResponse} returns this
*/
proto.openbank.v1.admin.UploadFileResponse.prototype.setKycuploadfile = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.openbank.v1.admin.UploadFileResponse} returns this
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.clearKycuploadfile = function() {
  return this.setKycuploadfile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.hasKycuploadfile = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string FileID = 2;
 * @return {string}
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.getFileid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.openbank.v1.admin.UploadFileResponse} returns this
 */
proto.openbank.v1.admin.UploadFileResponse.prototype.setFileid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.openbank.v1.admin.GetClientSearchType = {
  UNKNOWN: 0,
  ORGANIZATION: 1,
  EMAIL: 2
};

/**
 * @enum {number}
 */
proto.openbank.v1.admin.LiveAccessFilter = {
  NONE: 0,
  SANDBOX: 1,
  LIVE: 2
};

/**
 * @enum {number}
 */
proto.openbank.v1.admin.BankType = {
  PERSONAL: 0,
  CORPORATE: 1
};

/**
 * @enum {number}
 */
proto.openbank.v1.admin.AdminLogType = {
  UNKNOWN_ADMINLOG: 0,
  PROMOTE_LIVE_ACCESS: 1,
  REVOKE_LIVE_ACCESS: 2,
  APPROVE_KYC: 3,
  REJECT_KYC: 4,
  KYC_RESUBMISSION: 5,
  UPDATE_BUSINESSINFO: 6,
  DELETE_USER: 7
};

/**
 * @enum {number}
 */
proto.openbank.v1.admin.EmailAdvisoryTemplate = {
  UNKNOWN_EMAIL_ADVISORY_TEMPLATE: 0,
  BANK_PORTAL_UP: 1,
  BANK_SYSTEM_MAINTENANCE_FINISHED: 2,
  BANK_INTERMITTENT_CONNECTION_RESTORED: 3,
  BANK_SCHEDULED_MAINTENANCE_RESTORED: 4,
  BRANKAS_SYSTEM_UP: 5,
  BRANKAS_SCHEDULED_MAINTENANCE_RESTORED: 6,
  PAYMENT_RAIL_UP: 7,
  BANK_PORTAL_DOWN: 8,
  BANK_SYSTEM_MAINTENANCE: 9,
  BANK_INTERMITTENT_CONNECTION: 10,
  BANK_SCHEDULED_MAINTENANCE: 11,
  BRANKAS_SYSTEM_DOWN: 12,
  BRANKAS_SCHEDULED_MAINTENANCE: 13,
  PAYMENT_RAIL_DOWN: 14,
  CUSTOM: 15
};

goog.object.extend(exports, proto.openbank.v1.admin);
